export const mockAttendancesDataResponse = [
  {
    createdAt: '2022-11-25T13:22:55.000Z', //
    number: '1-1234567890',
    status: 'Resolvido', //
    subject: 'Incident', //
    id: '1-1234567890',
  },
];

export const mockAttendanceDataResponseApi = {
  zendesk: [
    {
      created_at: '2023-03-03T11:48:19Z',
      subject: 'Atendimento',
      status: 'new',
      id: 66221,

      ticket_form_id: 10485620954007,

      url: 'https://smileshelp1562260535.zendesk.com/api/v2/tickets/66221.json',
      external_id: null,
      via: { channel: 'api', source: { from: {}, to: {}, rel: null } },
      updated_at: '2023-03-03T11:48:19Z',
      type: null,
      raw_subject: 'Atendimento',
      description: 'teste logado',
      priority: 'normal',
      recipient: null,
      requester_id: 12825653103255,
      submitter_id: 12825653103255,
      custom_status_id: 1900005898905,
      assignee_id: null,
      organization_id: null,
      group_id: null,
      collaborator_ids: [],
      follower_ids: [],
      email_cc_ids: [],
      forum_topic_id: null,
      problem_id: null,
      has_incidents: false,
      is_public: true,
      due_at: null,
      tags: ['programacao_voebiz', 'voebiz'],
      custom_fields: [
        { id: 1500003491842, value: null },
        { id: 1900002677765, value: null },
        { id: 1500016050181, value: null },
        { id: 360054855174, value: null },
        { id: 360044574214, value: null },
        { id: 1500009107462, value: null },
        { id: 1500014614022, value: null },
        { id: 360046206474, value: null },
        { id: 360039366414, value: false },
        { id: 360056619793, value: null },
        { id: 360046205713, value: false },
        { id: 1500005882641, value: null },
        { id: 1500003491602, value: null },
        { id: 1500016170261, value: null },
        { id: 1500005881621, value: null },
        { id: 360029371414, value: null },
        { id: 360042433814, value: null },
        { id: 1500013044502, value: null },
        { id: 10066589064727, value: null },
        { id: 9175092306967, value: null },
        { id: 10066730691863, value: null },
        { id: 10072253674007, value: null },
        { id: 10066337872151, value: null },
        { id: 7861074279447, value: null },
        { id: 9242538098711, value: null },
        { id: 9070161708055, value: null },
        { id: 10066654086935, value: null },
        { id: 10066628529175, value: null },
        { id: 8818068641559, value: null },
        { id: 10072673444119, value: null },
        { id: 5245709279767, value: null },
        { id: 6654446037015, value: false },
        { id: 10067120059159, value: null },
        { id: 8415913931543, value: null },
        { id: 9242475919383, value: null },
        { id: 10067118227223, value: null },
        { id: 6654430446359, value: null },
        { id: 10809861837079, value: null },
        { id: 5398815741719, value: null },
        { id: 8817745637399, value: null },
        { id: 7111921349399, value: null },
        { id: 10066458623767, value: null },
        { id: 5549104021783, value: null },
        { id: 10067125060119, value: null },
        { id: 9242601707031, value: null },
        { id: 10288063109911, value: null },
        { id: 8207896604951, value: null },
        { id: 10066574439191, value: null },
        { id: 4938628592919, value: null },
        { id: 8427188843799, value: null },
        { id: 360024375833, value: null },
        { id: 360054855194, value: 'undefined undefined' },
        { id: 1500009107482, value: null },
        { id: 1500014614042, value: null },
        { id: 360024694813, value: null },
        { id: 360054517534, value: null },
        { id: 360046205733, value: false },
        { id: 1500012771621, value: null },
        { id: 1900007172645, value: null },
        { id: 1500013080102, value: null },
        { id: 360055357993, value: null },
        { id: 1500011612202, value: null },
        { id: 1500002063661, value: null },
        { id: 1500009107502, value: null },
        { id: 1500014614062, value: null },
        { id: 360057080373, value: null },
        { id: 1500003426101, value: null },
        { id: 1500014567221, value: null },
        { id: 1500016232502, value: null },
        { id: 1500003552822, value: null },
        { id: 360055358013, value: null },
        { id: 360029371454, value: null },
        { id: 1500012829502, value: null },
        { id: 1500002063681, value: null },
        { id: 1500015599681, value: null },
        { id: 1900007828545, value: null },
        { id: 360043769153, value: null },
        { id: 1500006002242, value: null },
        { id: 1500004939842, value: null },
        { id: 1500002789701, value: null },
        { id: 360043262533, value: null },
        { id: 1500005879621, value: null },
        { id: 360022833733, value: null },
        { id: 1500013137222, value: null },
        { id: 1500012020301, value: null },
        { id: 360054347854, value: null },
        { id: 360022693713, value: null },
        { id: 1500015526481, value: null },
        { id: 360055410513, value: false },
        { id: 360055358033, value: null },
        { id: 1900006065745, value: null },
        { id: 360054854994, value: null },
        { id: 360029371474, value: null },
        { id: 360024394834, value: null },
        { id: 360026636114, value: null },
        { id: 1500002063701, value: null },
        { id: 360043769173, value: null },
        { id: 360046230614, value: null },
        { id: 1500004426841, value: null },
        { id: 360048326233, value: null },
        { id: 1500003488601, value: null },
        { id: 360025747033, value: null },
        { id: 360043302234, value: null },
        { id: 1500004498782, value: null },
        { id: 360046205793, value: false },
        { id: 360055524193, value: null },
        { id: 1500012771681, value: null },
        { id: 360054347874, value: null },
        { id: 360035105634, value: null },
        { id: 1900007564645, value: null },
        { id: 360054855014, value: null },
        { id: 360024685933, value: null },
        { id: 1500004498802, value: null },
        { id: 360025770354, value: null },
        { id: 360025408114, value: null },
        { id: 1500005011061, value: null },
        { id: 360055524213, value: null },
        { id: 360054347894, value: null },
        { id: 360035105654, value: null },
        { id: 1500000652921, value: null },
        { id: 1500016047741, value: null },
        { id: 1500003488381, value: null },
        { id: 1500005265021, value: null },
        { id: 1500010996862, value: null },
        { id: 360044128894, value: null },
        { id: 1500009047681, value: null },
        { id: 360054420354, value: null },
        { id: 360039351173, value: false },
        { id: 1500012976261, value: null },
        { id: 1500004500102, value: null },
        { id: 1900006384265, value: null },
        { id: 1500003426441, value: null },
        { id: 360054347914, value: null },
        { id: 1500004428941, value: null },
        { id: 1500010327441, value: null },
        { id: 1500014706321, value: null },
        { id: 1500010996882, value: null },
        { id: 360023881874, value: null },
        { id: 1500006130581, value: null },
        { id: 1500002304661, value: null },
        { id: 360043302294, value: null },
        { id: 10490906150551, value: null },
        { id: 10072176074391, value: null },
        { id: 10067065842839, value: null },
        { id: 9381333577111, value: null },
        { id: 9381361892503, value: null },
        { id: 10066578063767, value: null },
        { id: 10815489721495, value: null },
        { id: 10816761509015, value: null },
        { id: 10072199358615, value: '5500' },
        { id: 7467593986199, value: null },
        { id: 10489489032343, value: null },
        { id: 10066413983895, value: null },
        { id: 10072710890135, value: null },
        { id: 4942600389271, value: null },
        { id: 10072624974743, value: null },
        { id: 10066519447959, value: null },
        { id: 10072200767127, value: null },
        { id: 7780575995799, value: false },
        { id: 9242612659351, value: null },
        { id: 5699464329111, value: null },
        { id: 10066793791383, value: null },
        { id: 1500004260762, value: null },
        { id: 360036674714, value: null },
        { id: 1500012020381, value: null },
        { id: 1500000249501, value: false },
        { id: 1500003426461, value: null },
        { id: 360054347934, value: null },
        { id: 360033055134, value: null },
        { id: 1500004428961, value: null },
        { id: 1500002107042, value: null },
        { id: 1500003492002, value: null },
        { id: 360043836834, value: null },
        { id: 1900000732325, value: null },
        { id: 360058106533, value: null },
        { id: 360026607273, value: null },
        { id: 1500001896361, value: false },
        { id: 1500014750122, value: null },
        { id: 1500005886381, value: null },
        { id: 1500001187501, value: null },
        { id: 1500009990062, value: null },
        { id: 1500004500142, value: null },
        { id: 1500004260782, value: null },
        { id: 360050038194, value: null },
        { id: 1500011634101, value: false },
        { id: 1500004428981, value: null },
        { id: 1500003492022, value: null },
        { id: 360050038714, value: null },
        { id: 360055025594, value: null },
        { id: 1500003425981, value: null },
        { id: 1500001459902, value: null },
        { id: 1500004323521, value: null },
        { id: 1500012320962, value: null },
        { id: 1500003491782, value: null },
        { id: 360044575434, value: null },
        { id: 1500009047501, value: null },
        { id: 360022783694, value: null },
        { id: 360056319953, value: false },
        { id: 1500003426001, value: null },
        { id: 1500005230802, value: null },
        { id: 1500001459922, value: null },
        { id: 360023899093, value: 'voebiz' },
        { id: 1500003426261, value: null },
        { id: 1500009990102, value: null },
        { id: 1500004359382, value: null },
        { id: 1500014598102, value: null },
        { id: 1900001641945, value: null },
        { id: 1900004095705, value: null },
        { id: 1500003491802, value: null },
        { id: 360029369053, value: null },
        { id: 360025384673, value: null },
        { id: 1500005701601, value: null },
        { id: 1900004048865, value: null },
        { id: 360055711974, value: null },
        { id: 1900007172585, value: null },
        { id: 360044545773, value: null },
        { id: 1500010702061, value: false },
        { id: 360024904433, value: false },
        { id: 360029369073, value: null },
        { id: 360046903793, value: null },
        { id: 1500009120501, value: null },
        { id: 1500012019961, value: null },
        { id: 1500009927161, value: null },
        { id: 360055733753, value: null },
        { id: 1500009989882, value: null },
        { id: 360046922234, value: null },
        { id: 1500003491582, value: null },
        { id: 12037702489623, value: null },
        { id: 10895116347159, value: null },
        { id: 10902682877207, value: null },
        { id: 11132283142167, value: null },
        { id: 10900266631447, value: null },
        { id: 10895118911767, value: null },
        { id: 11132967802391, value: null },
        { id: 11625474579223, value: false },
        { id: 10900727687447, value: null },
        { id: 10899211972631, value: false },
        { id: 10898980892951, value: null },
        { id: 12659065713431, value: null },
        { id: 11171001366039, value: null },
        { id: 12668046967063, value: null },
        { id: 11132540980247, value: null },
        { id: 11132973190935, value: null },
        { id: 11132484690967, value: null },
        { id: 10894727623447, value: false },
        { id: 10901590554903, value: null },
        { id: 11027113432343, value: null },
        { id: 11027072477463, value: null },
        { id: 11132462361367, value: null },
        { id: 11131483387415, value: null },
        { id: 10901613970071, value: null },
        { id: 10838234563735, value: null },
        { id: 10816826253975, value: null },
        { id: 12327195518615, value: null },
        { id: 11170988767639, value: null },
        { id: 10902662038679, value: null },
        { id: 11172429785239, value: null },
        { id: 10901586603671, value: null },
        { id: 10903495668887, value: null },
        { id: 12826912126359, value: null },
        { id: 10835085063831, value: null },
        { id: 10903411652759, value: null },
        { id: 12722875890327, value: null },
        { id: 11171000320919, value: null },
        { id: 10899989432215, value: null },
        { id: 12719289763991, value: null },
        { id: 11132974899095, value: null },
        { id: 10899057188759, value: null },
        { id: 10900731766679, value: null },
        { id: 11172554846871, value: null },
        { id: 11616660009623, value: null },
        { id: 10895155905175, value: null },
        { id: 12148354172567, value: null },
        { id: 11132337387671, value: null },
      ],
      satisfaction_rating: { score: 'unoffered' },
      sharing_agreement_ids: [],
      fields: [
        { id: 1500003491842, value: null },
        { id: 1900002677765, value: null },
        { id: 1500016050181, value: null },
        { id: 360054855174, value: null },
        { id: 360044574214, value: null },
        { id: 1500009107462, value: null },
        { id: 1500014614022, value: null },
        { id: 360046206474, value: null },
        { id: 360039366414, value: false },
        { id: 360056619793, value: null },
        { id: 360046205713, value: false },
        { id: 1500005882641, value: null },
        { id: 1500003491602, value: null },
        { id: 1500016170261, value: null },
        { id: 1500005881621, value: null },
        { id: 360029371414, value: null },
        { id: 360042433814, value: null },
        { id: 1500013044502, value: null },
        { id: 10066589064727, value: null },
        { id: 9175092306967, value: null },
        { id: 10066730691863, value: null },
        { id: 10072253674007, value: null },
        { id: 10066337872151, value: null },
        { id: 7861074279447, value: null },
        { id: 9242538098711, value: null },
        { id: 9070161708055, value: null },
        { id: 10066654086935, value: null },
        { id: 10066628529175, value: null },
        { id: 8818068641559, value: null },
        { id: 10072673444119, value: null },
        { id: 5245709279767, value: null },
        { id: 6654446037015, value: false },
        { id: 10067120059159, value: null },
        { id: 8415913931543, value: null },
        { id: 9242475919383, value: null },
        { id: 10067118227223, value: null },
        { id: 6654430446359, value: null },
        { id: 10809861837079, value: null },
        { id: 5398815741719, value: null },
        { id: 8817745637399, value: null },
        { id: 7111921349399, value: null },
        { id: 10066458623767, value: null },
        { id: 5549104021783, value: null },
        { id: 10067125060119, value: null },
        { id: 9242601707031, value: null },
        { id: 10288063109911, value: null },
        { id: 8207896604951, value: null },
        { id: 10066574439191, value: null },
        { id: 4938628592919, value: null },
        { id: 8427188843799, value: null },
        { id: 360024375833, value: null },
        { id: 360054855194, value: 'undefined undefined' },
        { id: 1500009107482, value: null },
        { id: 1500014614042, value: null },
        { id: 360024694813, value: null },
        { id: 360054517534, value: null },
        { id: 360046205733, value: false },
        { id: 1500012771621, value: null },
        { id: 1900007172645, value: null },
        { id: 1500013080102, value: null },
        { id: 360055357993, value: null },
        { id: 1500011612202, value: null },
        { id: 1500002063661, value: null },
        { id: 1500009107502, value: null },
        { id: 1500014614062, value: null },
        { id: 360057080373, value: null },
        { id: 1500003426101, value: null },
        { id: 1500014567221, value: null },
        { id: 1500016232502, value: null },
        { id: 1500003552822, value: null },
        { id: 360055358013, value: null },
        { id: 360029371454, value: null },
        { id: 1500012829502, value: null },
        { id: 1500002063681, value: null },
        { id: 1500015599681, value: null },
        { id: 1900007828545, value: null },
        { id: 360043769153, value: null },
        { id: 1500006002242, value: null },
        { id: 1500004939842, value: null },
        { id: 1500002789701, value: null },
        { id: 360043262533, value: null },
        { id: 1500005879621, value: null },
        { id: 360022833733, value: null },
        { id: 1500013137222, value: null },
        { id: 1500012020301, value: null },
        { id: 360054347854, value: null },
        { id: 360022693713, value: null },
        { id: 1500015526481, value: null },
        { id: 360055410513, value: false },
        { id: 360055358033, value: null },
        { id: 1900006065745, value: null },
        { id: 360054854994, value: null },
        { id: 360029371474, value: null },
        { id: 360024394834, value: null },
        { id: 360026636114, value: null },
        { id: 1500002063701, value: null },
        { id: 360043769173, value: null },
        { id: 360046230614, value: null },
        { id: 1500004426841, value: null },
        { id: 360048326233, value: null },
        { id: 1500003488601, value: null },
        { id: 360025747033, value: null },
        { id: 360043302234, value: null },
        { id: 1500004498782, value: null },
        { id: 360046205793, value: false },
        { id: 360055524193, value: null },
        { id: 1500012771681, value: null },
        { id: 360054347874, value: null },
        { id: 360035105634, value: null },
        { id: 1900007564645, value: null },
        { id: 360054855014, value: null },
        { id: 360024685933, value: null },
        { id: 1500004498802, value: null },
        { id: 360025770354, value: null },
        { id: 360025408114, value: null },
        { id: 1500005011061, value: null },
        { id: 360055524213, value: null },
        { id: 360054347894, value: null },
        { id: 360035105654, value: null },
        { id: 1500000652921, value: null },
        { id: 1500016047741, value: null },
        { id: 1500003488381, value: null },
        { id: 1500005265021, value: null },
        { id: 1500010996862, value: null },
        { id: 360044128894, value: null },
        { id: 1500009047681, value: null },
        { id: 360054420354, value: null },
        { id: 360039351173, value: false },
        { id: 1500012976261, value: null },
        { id: 1500004500102, value: null },
        { id: 1900006384265, value: null },
        { id: 1500003426441, value: null },
        { id: 360054347914, value: null },
        { id: 1500004428941, value: null },
        { id: 1500010327441, value: null },
        { id: 1500014706321, value: null },
        { id: 1500010996882, value: null },
        { id: 360023881874, value: null },
        { id: 1500006130581, value: null },
        { id: 1500002304661, value: null },
        { id: 360043302294, value: null },
        { id: 10490906150551, value: null },
        { id: 10072176074391, value: null },
        { id: 10067065842839, value: null },
        { id: 9381333577111, value: null },
        { id: 9381361892503, value: null },
        { id: 10066578063767, value: null },
        { id: 10815489721495, value: null },
        { id: 10816761509015, value: null },
        { id: 10072199358615, value: '5500' },
        { id: 7467593986199, value: null },
        { id: 10489489032343, value: null },
        { id: 10066413983895, value: null },
        { id: 10072710890135, value: null },
        { id: 4942600389271, value: null },
        { id: 10072624974743, value: null },
        { id: 10066519447959, value: null },
        { id: 10072200767127, value: null },
        { id: 7780575995799, value: false },
        { id: 9242612659351, value: null },
        { id: 5699464329111, value: null },
        { id: 10066793791383, value: null },
        { id: 1500004260762, value: null },
        { id: 360036674714, value: null },
        { id: 1500012020381, value: null },
        { id: 1500000249501, value: false },
        { id: 1500003426461, value: null },
        { id: 360054347934, value: null },
        { id: 360033055134, value: null },
        { id: 1500004428961, value: null },
        { id: 1500002107042, value: null },
        { id: 1500003492002, value: null },
        { id: 360043836834, value: null },
        { id: 1900000732325, value: null },
        { id: 360058106533, value: null },
        { id: 360026607273, value: null },
        { id: 1500001896361, value: false },
        { id: 1500014750122, value: null },
        { id: 1500005886381, value: null },
        { id: 1500001187501, value: null },
        { id: 1500009990062, value: null },
        { id: 1500004500142, value: null },
        { id: 1500004260782, value: null },
        { id: 360050038194, value: null },
        { id: 1500011634101, value: false },
        { id: 1500004428981, value: null },
        { id: 1500003492022, value: null },
        { id: 360050038714, value: null },
        { id: 360055025594, value: null },
        { id: 1500003425981, value: null },
        { id: 1500001459902, value: null },
        { id: 1500004323521, value: null },
        { id: 1500012320962, value: null },
        { id: 1500003491782, value: null },
        { id: 360044575434, value: null },
        { id: 1500009047501, value: null },
        { id: 360022783694, value: null },
        { id: 360056319953, value: false },
        { id: 1500003426001, value: null },
        { id: 1500005230802, value: null },
        { id: 1500001459922, value: null },
        { id: 360023899093, value: 'voebiz' },
        { id: 1500003426261, value: null },
        { id: 1500009990102, value: null },
        { id: 1500004359382, value: null },
        { id: 1500014598102, value: null },
        { id: 1900001641945, value: null },
        { id: 1900004095705, value: null },
        { id: 1500003491802, value: null },
        { id: 360029369053, value: null },
        { id: 360025384673, value: null },
        { id: 1500005701601, value: null },
        { id: 1900004048865, value: null },
        { id: 360055711974, value: null },
        { id: 1900007172585, value: null },
        { id: 360044545773, value: null },
        { id: 1500010702061, value: false },
        { id: 360024904433, value: false },
        { id: 360029369073, value: null },
        { id: 360046903793, value: null },
        { id: 1500009120501, value: null },
        { id: 1500012019961, value: null },
        { id: 1500009927161, value: null },
        { id: 360055733753, value: null },
        { id: 1500009989882, value: null },
        { id: 360046922234, value: null },
        { id: 1500003491582, value: null },
        { id: 12037702489623, value: null },
        { id: 10895116347159, value: null },
        { id: 10902682877207, value: null },
        { id: 11132283142167, value: null },
        { id: 10900266631447, value: null },
        { id: 10895118911767, value: null },
        { id: 11132967802391, value: null },
        { id: 11625474579223, value: false },
        { id: 10900727687447, value: null },
        { id: 10899211972631, value: false },
        { id: 10898980892951, value: null },
        { id: 12659065713431, value: null },
        { id: 11171001366039, value: null },
        { id: 12668046967063, value: null },
        { id: 11132540980247, value: null },
        { id: 11132973190935, value: null },
        { id: 11132484690967, value: null },
        { id: 10894727623447, value: false },
        { id: 10901590554903, value: null },
        { id: 11027113432343, value: null },
        { id: 11027072477463, value: null },
        { id: 11132462361367, value: null },
        { id: 11131483387415, value: null },
        { id: 10901613970071, value: null },
        { id: 10838234563735, value: null },
        { id: 10816826253975, value: null },
        { id: 12327195518615, value: null },
        { id: 11170988767639, value: null },
        { id: 10902662038679, value: null },
        { id: 11172429785239, value: null },
        { id: 10901586603671, value: null },
        { id: 10903495668887, value: null },
        { id: 12826912126359, value: null },
        { id: 10835085063831, value: null },
        { id: 10903411652759, value: null },
        { id: 12722875890327, value: null },
        { id: 11171000320919, value: null },
        { id: 10899989432215, value: null },
        { id: 12719289763991, value: null },
        { id: 11132974899095, value: null },
        { id: 10899057188759, value: null },
        { id: 10900731766679, value: null },
        { id: 11172554846871, value: null },
        { id: 11616660009623, value: null },
        { id: 10895155905175, value: null },
        { id: 12148354172567, value: null },
        { id: 11132337387671, value: null },
      ],
      followup_ids: [],
      brand_id: 10485577125271,
      allow_channelback: false,
      allow_attachments: true,
    },
    {
      created_at: '2023-03-03T11:48:19Z',
      subject: 'Atendimento',
      status: 'new',
      id: 66221,

      ticket_form_id: 10485620954007,

      url: 'https://smileshelp1562260535.zendesk.com/api/v2/tickets/66221.json',
      external_id: null,
      via: { channel: 'api', source: { from: {}, to: {}, rel: null } },
      updated_at: '2023-03-03T11:48:19Z',
      type: null,
      raw_subject: 'Atendimento',
      description: 'teste logado',
      priority: 'normal',
      recipient: null,
      requester_id: 12825653103255,
      submitter_id: 12825653103255,
      custom_status_id: 1900005898905,
      assignee_id: null,
      organization_id: null,
      group_id: null,
      collaborator_ids: [],
      follower_ids: [],
      email_cc_ids: [],
      forum_topic_id: null,
      problem_id: null,
      has_incidents: false,
      is_public: true,
      due_at: null,
      tags: ['programacao_voebiz', 'voebiz'],
      custom_fields: [
        { id: 1500003491842, value: null },
        { id: 1900002677765, value: null },
        { id: 1500016050181, value: null },
        { id: 360054855174, value: null },
        { id: 360044574214, value: null },
        { id: 1500009107462, value: null },
        { id: 1500014614022, value: null },
        { id: 360046206474, value: null },
        { id: 360039366414, value: false },
        { id: 360056619793, value: null },
        { id: 360046205713, value: false },
        { id: 1500005882641, value: null },
        { id: 1500003491602, value: null },
        { id: 1500016170261, value: null },
        { id: 1500005881621, value: null },
        { id: 360029371414, value: null },
        { id: 360042433814, value: null },
        { id: 1500013044502, value: null },
        { id: 10066589064727, value: null },
        { id: 9175092306967, value: null },
        { id: 10066730691863, value: null },
        { id: 10072253674007, value: null },
        { id: 10066337872151, value: null },
        { id: 7861074279447, value: null },
        { id: 9242538098711, value: null },
        { id: 9070161708055, value: null },
        { id: 10066654086935, value: null },
        { id: 10066628529175, value: null },
        { id: 8818068641559, value: null },
        { id: 10072673444119, value: null },
        { id: 5245709279767, value: null },
        { id: 6654446037015, value: false },
        { id: 10067120059159, value: null },
        { id: 8415913931543, value: null },
        { id: 9242475919383, value: null },
        { id: 10067118227223, value: null },
        { id: 6654430446359, value: null },
        { id: 10809861837079, value: null },
        { id: 5398815741719, value: null },
        { id: 8817745637399, value: null },
        { id: 7111921349399, value: null },
        { id: 10066458623767, value: null },
        { id: 5549104021783, value: null },
        { id: 10067125060119, value: null },
        { id: 9242601707031, value: null },
        { id: 10288063109911, value: null },
        { id: 8207896604951, value: null },
        { id: 10066574439191, value: null },
        { id: 4938628592919, value: null },
        { id: 8427188843799, value: null },
        { id: 360024375833, value: null },
        { id: 360054855194, value: 'undefined undefined' },
        { id: 1500009107482, value: null },
        { id: 1500014614042, value: null },
        { id: 360024694813, value: null },
        { id: 360054517534, value: null },
        { id: 360046205733, value: false },
        { id: 1500012771621, value: null },
        { id: 1900007172645, value: null },
        { id: 1500013080102, value: null },
        { id: 360055357993, value: null },
        { id: 1500011612202, value: null },
        { id: 1500002063661, value: null },
        { id: 1500009107502, value: null },
        { id: 1500014614062, value: null },
        { id: 360057080373, value: null },
        { id: 1500003426101, value: null },
        { id: 1500014567221, value: null },
        { id: 1500016232502, value: null },
        { id: 1500003552822, value: null },
        { id: 360055358013, value: null },
        { id: 360029371454, value: null },
        { id: 1500012829502, value: null },
        { id: 1500002063681, value: null },
        { id: 1500015599681, value: null },
        { id: 1900007828545, value: null },
        { id: 360043769153, value: null },
        { id: 1500006002242, value: null },
        { id: 1500004939842, value: null },
        { id: 1500002789701, value: null },
        { id: 360043262533, value: null },
        { id: 1500005879621, value: null },
        { id: 360022833733, value: null },
        { id: 1500013137222, value: null },
        { id: 1500012020301, value: null },
        { id: 360054347854, value: null },
        { id: 360022693713, value: null },
        { id: 1500015526481, value: null },
        { id: 360055410513, value: false },
        { id: 360055358033, value: null },
        { id: 1900006065745, value: null },
        { id: 360054854994, value: null },
        { id: 360029371474, value: null },
        { id: 360024394834, value: null },
        { id: 360026636114, value: null },
        { id: 1500002063701, value: null },
        { id: 360043769173, value: null },
        { id: 360046230614, value: null },
        { id: 1500004426841, value: null },
        { id: 360048326233, value: null },
        { id: 1500003488601, value: null },
        { id: 360025747033, value: null },
        { id: 360043302234, value: null },
        { id: 1500004498782, value: null },
        { id: 360046205793, value: false },
        { id: 360055524193, value: null },
        { id: 1500012771681, value: null },
        { id: 360054347874, value: null },
        { id: 360035105634, value: null },
        { id: 1900007564645, value: null },
        { id: 360054855014, value: null },
        { id: 360024685933, value: null },
        { id: 1500004498802, value: null },
        { id: 360025770354, value: null },
        { id: 360025408114, value: null },
        { id: 1500005011061, value: null },
        { id: 360055524213, value: null },
        { id: 360054347894, value: null },
        { id: 360035105654, value: null },
        { id: 1500000652921, value: null },
        { id: 1500016047741, value: null },
        { id: 1500003488381, value: null },
        { id: 1500005265021, value: null },
        { id: 1500010996862, value: null },
        { id: 360044128894, value: null },
        { id: 1500009047681, value: null },
        { id: 360054420354, value: null },
        { id: 360039351173, value: false },
        { id: 1500012976261, value: null },
        { id: 1500004500102, value: null },
        { id: 1900006384265, value: null },
        { id: 1500003426441, value: null },
        { id: 360054347914, value: null },
        { id: 1500004428941, value: null },
        { id: 1500010327441, value: null },
        { id: 1500014706321, value: null },
        { id: 1500010996882, value: null },
        { id: 360023881874, value: null },
        { id: 1500006130581, value: null },
        { id: 1500002304661, value: null },
        { id: 360043302294, value: null },
        { id: 10490906150551, value: null },
        { id: 10072176074391, value: null },
        { id: 10067065842839, value: null },
        { id: 9381333577111, value: null },
        { id: 9381361892503, value: null },
        { id: 10066578063767, value: null },
        { id: 10815489721495, value: null },
        { id: 10816761509015, value: null },
        { id: 10072199358615, value: '5500' },
        { id: 7467593986199, value: null },
        { id: 10489489032343, value: null },
        { id: 10066413983895, value: null },
        { id: 10072710890135, value: null },
        { id: 4942600389271, value: null },
        { id: 10072624974743, value: null },
        { id: 10066519447959, value: null },
        { id: 10072200767127, value: null },
        { id: 7780575995799, value: false },
        { id: 9242612659351, value: null },
        { id: 5699464329111, value: null },
        { id: 10066793791383, value: null },
        { id: 1500004260762, value: null },
        { id: 360036674714, value: null },
        { id: 1500012020381, value: null },
        { id: 1500000249501, value: false },
        { id: 1500003426461, value: null },
        { id: 360054347934, value: null },
        { id: 360033055134, value: null },
        { id: 1500004428961, value: null },
        { id: 1500002107042, value: null },
        { id: 1500003492002, value: null },
        { id: 360043836834, value: null },
        { id: 1900000732325, value: null },
        { id: 360058106533, value: null },
        { id: 360026607273, value: null },
        { id: 1500001896361, value: false },
        { id: 1500014750122, value: null },
        { id: 1500005886381, value: null },
        { id: 1500001187501, value: null },
        { id: 1500009990062, value: null },
        { id: 1500004500142, value: null },
        { id: 1500004260782, value: null },
        { id: 360050038194, value: null },
        { id: 1500011634101, value: false },
        { id: 1500004428981, value: null },
        { id: 1500003492022, value: null },
        { id: 360050038714, value: null },
        { id: 360055025594, value: null },
        { id: 1500003425981, value: null },
        { id: 1500001459902, value: null },
        { id: 1500004323521, value: null },
        { id: 1500012320962, value: null },
        { id: 1500003491782, value: null },
        { id: 360044575434, value: null },
        { id: 1500009047501, value: null },
        { id: 360022783694, value: null },
        { id: 360056319953, value: false },
        { id: 1500003426001, value: null },
        { id: 1500005230802, value: null },
        { id: 1500001459922, value: null },
        { id: 360023899093, value: 'voebiz' },
        { id: 1500003426261, value: null },
        { id: 1500009990102, value: null },
        { id: 1500004359382, value: null },
        { id: 1500014598102, value: null },
        { id: 1900001641945, value: null },
        { id: 1900004095705, value: null },
        { id: 1500003491802, value: null },
        { id: 360029369053, value: null },
        { id: 360025384673, value: null },
        { id: 1500005701601, value: null },
        { id: 1900004048865, value: null },
        { id: 360055711974, value: null },
        { id: 1900007172585, value: null },
        { id: 360044545773, value: null },
        { id: 1500010702061, value: false },
        { id: 360024904433, value: false },
        { id: 360029369073, value: null },
        { id: 360046903793, value: null },
        { id: 1500009120501, value: null },
        { id: 1500012019961, value: null },
        { id: 1500009927161, value: null },
        { id: 360055733753, value: null },
        { id: 1500009989882, value: null },
        { id: 360046922234, value: null },
        { id: 1500003491582, value: null },
        { id: 12037702489623, value: null },
        { id: 10895116347159, value: null },
        { id: 10902682877207, value: null },
        { id: 11132283142167, value: null },
        { id: 10900266631447, value: null },
        { id: 10895118911767, value: null },
        { id: 11132967802391, value: null },
        { id: 11625474579223, value: false },
        { id: 10900727687447, value: null },
        { id: 10899211972631, value: false },
        { id: 10898980892951, value: null },
        { id: 12659065713431, value: null },
        { id: 11171001366039, value: null },
        { id: 12668046967063, value: null },
        { id: 11132540980247, value: null },
        { id: 11132973190935, value: null },
        { id: 11132484690967, value: null },
        { id: 10894727623447, value: false },
        { id: 10901590554903, value: null },
        { id: 11027113432343, value: null },
        { id: 11027072477463, value: null },
        { id: 11132462361367, value: null },
        { id: 11131483387415, value: null },
        { id: 10901613970071, value: null },
        { id: 10838234563735, value: null },
        { id: 10816826253975, value: null },
        { id: 12327195518615, value: null },
        { id: 11170988767639, value: null },
        { id: 10902662038679, value: null },
        { id: 11172429785239, value: null },
        { id: 10901586603671, value: null },
        { id: 10903495668887, value: null },
        { id: 12826912126359, value: null },
        { id: 10835085063831, value: null },
        { id: 10903411652759, value: null },
        { id: 12722875890327, value: null },
        { id: 11171000320919, value: null },
        { id: 10899989432215, value: null },
        { id: 12719289763991, value: null },
        { id: 11132974899095, value: null },
        { id: 10899057188759, value: null },
        { id: 10900731766679, value: null },
        { id: 11172554846871, value: null },
        { id: 11616660009623, value: null },
        { id: 10895155905175, value: null },
        { id: 12148354172567, value: null },
        { id: 11132337387671, value: null },
      ],
      satisfaction_rating: { score: 'unoffered' },
      sharing_agreement_ids: [],
      fields: [
        { id: 1500003491842, value: null },
        { id: 1900002677765, value: null },
        { id: 1500016050181, value: null },
        { id: 360054855174, value: null },
        { id: 360044574214, value: null },
        { id: 1500009107462, value: null },
        { id: 1500014614022, value: null },
        { id: 360046206474, value: null },
        { id: 360039366414, value: false },
        { id: 360056619793, value: null },
        { id: 360046205713, value: false },
        { id: 1500005882641, value: null },
        { id: 1500003491602, value: null },
        { id: 1500016170261, value: null },
        { id: 1500005881621, value: null },
        { id: 360029371414, value: null },
        { id: 360042433814, value: null },
        { id: 1500013044502, value: null },
        { id: 10066589064727, value: null },
        { id: 9175092306967, value: null },
        { id: 10066730691863, value: null },
        { id: 10072253674007, value: null },
        { id: 10066337872151, value: null },
        { id: 7861074279447, value: null },
        { id: 9242538098711, value: null },
        { id: 9070161708055, value: null },
        { id: 10066654086935, value: null },
        { id: 10066628529175, value: null },
        { id: 8818068641559, value: null },
        { id: 10072673444119, value: null },
        { id: 5245709279767, value: null },
        { id: 6654446037015, value: false },
        { id: 10067120059159, value: null },
        { id: 8415913931543, value: null },
        { id: 9242475919383, value: null },
        { id: 10067118227223, value: null },
        { id: 6654430446359, value: null },
        { id: 10809861837079, value: null },
        { id: 5398815741719, value: null },
        { id: 8817745637399, value: null },
        { id: 7111921349399, value: null },
        { id: 10066458623767, value: null },
        { id: 5549104021783, value: null },
        { id: 10067125060119, value: null },
        { id: 9242601707031, value: null },
        { id: 10288063109911, value: null },
        { id: 8207896604951, value: null },
        { id: 10066574439191, value: null },
        { id: 4938628592919, value: null },
        { id: 8427188843799, value: null },
        { id: 360024375833, value: null },
        { id: 360054855194, value: 'undefined undefined' },
        { id: 1500009107482, value: null },
        { id: 1500014614042, value: null },
        { id: 360024694813, value: null },
        { id: 360054517534, value: null },
        { id: 360046205733, value: false },
        { id: 1500012771621, value: null },
        { id: 1900007172645, value: null },
        { id: 1500013080102, value: null },
        { id: 360055357993, value: null },
        { id: 1500011612202, value: null },
        { id: 1500002063661, value: null },
        { id: 1500009107502, value: null },
        { id: 1500014614062, value: null },
        { id: 360057080373, value: null },
        { id: 1500003426101, value: null },
        { id: 1500014567221, value: null },
        { id: 1500016232502, value: null },
        { id: 1500003552822, value: null },
        { id: 360055358013, value: null },
        { id: 360029371454, value: null },
        { id: 1500012829502, value: null },
        { id: 1500002063681, value: null },
        { id: 1500015599681, value: null },
        { id: 1900007828545, value: null },
        { id: 360043769153, value: null },
        { id: 1500006002242, value: null },
        { id: 1500004939842, value: null },
        { id: 1500002789701, value: null },
        { id: 360043262533, value: null },
        { id: 1500005879621, value: null },
        { id: 360022833733, value: null },
        { id: 1500013137222, value: null },
        { id: 1500012020301, value: null },
        { id: 360054347854, value: null },
        { id: 360022693713, value: null },
        { id: 1500015526481, value: null },
        { id: 360055410513, value: false },
        { id: 360055358033, value: null },
        { id: 1900006065745, value: null },
        { id: 360054854994, value: null },
        { id: 360029371474, value: null },
        { id: 360024394834, value: null },
        { id: 360026636114, value: null },
        { id: 1500002063701, value: null },
        { id: 360043769173, value: null },
        { id: 360046230614, value: null },
        { id: 1500004426841, value: null },
        { id: 360048326233, value: null },
        { id: 1500003488601, value: null },
        { id: 360025747033, value: null },
        { id: 360043302234, value: null },
        { id: 1500004498782, value: null },
        { id: 360046205793, value: false },
        { id: 360055524193, value: null },
        { id: 1500012771681, value: null },
        { id: 360054347874, value: null },
        { id: 360035105634, value: null },
        { id: 1900007564645, value: null },
        { id: 360054855014, value: null },
        { id: 360024685933, value: null },
        { id: 1500004498802, value: null },
        { id: 360025770354, value: null },
        { id: 360025408114, value: null },
        { id: 1500005011061, value: null },
        { id: 360055524213, value: null },
        { id: 360054347894, value: null },
        { id: 360035105654, value: null },
        { id: 1500000652921, value: null },
        { id: 1500016047741, value: null },
        { id: 1500003488381, value: null },
        { id: 1500005265021, value: null },
        { id: 1500010996862, value: null },
        { id: 360044128894, value: null },
        { id: 1500009047681, value: null },
        { id: 360054420354, value: null },
        { id: 360039351173, value: false },
        { id: 1500012976261, value: null },
        { id: 1500004500102, value: null },
        { id: 1900006384265, value: null },
        { id: 1500003426441, value: null },
        { id: 360054347914, value: null },
        { id: 1500004428941, value: null },
        { id: 1500010327441, value: null },
        { id: 1500014706321, value: null },
        { id: 1500010996882, value: null },
        { id: 360023881874, value: null },
        { id: 1500006130581, value: null },
        { id: 1500002304661, value: null },
        { id: 360043302294, value: null },
        { id: 10490906150551, value: null },
        { id: 10072176074391, value: null },
        { id: 10067065842839, value: null },
        { id: 9381333577111, value: null },
        { id: 9381361892503, value: null },
        { id: 10066578063767, value: null },
        { id: 10815489721495, value: null },
        { id: 10816761509015, value: null },
        { id: 10072199358615, value: '5500' },
        { id: 7467593986199, value: null },
        { id: 10489489032343, value: null },
        { id: 10066413983895, value: null },
        { id: 10072710890135, value: null },
        { id: 4942600389271, value: null },
        { id: 10072624974743, value: null },
        { id: 10066519447959, value: null },
        { id: 10072200767127, value: null },
        { id: 7780575995799, value: false },
        { id: 9242612659351, value: null },
        { id: 5699464329111, value: null },
        { id: 10066793791383, value: null },
        { id: 1500004260762, value: null },
        { id: 360036674714, value: null },
        { id: 1500012020381, value: null },
        { id: 1500000249501, value: false },
        { id: 1500003426461, value: null },
        { id: 360054347934, value: null },
        { id: 360033055134, value: null },
        { id: 1500004428961, value: null },
        { id: 1500002107042, value: null },
        { id: 1500003492002, value: null },
        { id: 360043836834, value: null },
        { id: 1900000732325, value: null },
        { id: 360058106533, value: null },
        { id: 360026607273, value: null },
        { id: 1500001896361, value: false },
        { id: 1500014750122, value: null },
        { id: 1500005886381, value: null },
        { id: 1500001187501, value: null },
        { id: 1500009990062, value: null },
        { id: 1500004500142, value: null },
        { id: 1500004260782, value: null },
        { id: 360050038194, value: null },
        { id: 1500011634101, value: false },
        { id: 1500004428981, value: null },
        { id: 1500003492022, value: null },
        { id: 360050038714, value: null },
        { id: 360055025594, value: null },
        { id: 1500003425981, value: null },
        { id: 1500001459902, value: null },
        { id: 1500004323521, value: null },
        { id: 1500012320962, value: null },
        { id: 1500003491782, value: null },
        { id: 360044575434, value: null },
        { id: 1500009047501, value: null },
        { id: 360022783694, value: null },
        { id: 360056319953, value: false },
        { id: 1500003426001, value: null },
        { id: 1500005230802, value: null },
        { id: 1500001459922, value: null },
        { id: 360023899093, value: 'voebiz' },
        { id: 1500003426261, value: null },
        { id: 1500009990102, value: null },
        { id: 1500004359382, value: null },
        { id: 1500014598102, value: null },
        { id: 1900001641945, value: null },
        { id: 1900004095705, value: null },
        { id: 1500003491802, value: null },
        { id: 360029369053, value: null },
        { id: 360025384673, value: null },
        { id: 1500005701601, value: null },
        { id: 1900004048865, value: null },
        { id: 360055711974, value: null },
        { id: 1900007172585, value: null },
        { id: 360044545773, value: null },
        { id: 1500010702061, value: false },
        { id: 360024904433, value: false },
        { id: 360029369073, value: null },
        { id: 360046903793, value: null },
        { id: 1500009120501, value: null },
        { id: 1500012019961, value: null },
        { id: 1500009927161, value: null },
        { id: 360055733753, value: null },
        { id: 1500009989882, value: null },
        { id: 360046922234, value: null },
        { id: 1500003491582, value: null },
        { id: 12037702489623, value: null },
        { id: 10895116347159, value: null },
        { id: 10902682877207, value: null },
        { id: 11132283142167, value: null },
        { id: 10900266631447, value: null },
        { id: 10895118911767, value: null },
        { id: 11132967802391, value: null },
        { id: 11625474579223, value: false },
        { id: 10900727687447, value: null },
        { id: 10899211972631, value: false },
        { id: 10898980892951, value: null },
        { id: 12659065713431, value: null },
        { id: 11171001366039, value: null },
        { id: 12668046967063, value: null },
        { id: 11132540980247, value: null },
        { id: 11132973190935, value: null },
        { id: 11132484690967, value: null },
        { id: 10894727623447, value: false },
        { id: 10901590554903, value: null },
        { id: 11027113432343, value: null },
        { id: 11027072477463, value: null },
        { id: 11132462361367, value: null },
        { id: 11131483387415, value: null },
        { id: 10901613970071, value: null },
        { id: 10838234563735, value: null },
        { id: 10816826253975, value: null },
        { id: 12327195518615, value: null },
        { id: 11170988767639, value: null },
        { id: 10902662038679, value: null },
        { id: 11172429785239, value: null },
        { id: 10901586603671, value: null },
        { id: 10903495668887, value: null },
        { id: 12826912126359, value: null },
        { id: 10835085063831, value: null },
        { id: 10903411652759, value: null },
        { id: 12722875890327, value: null },
        { id: 11171000320919, value: null },
        { id: 10899989432215, value: null },
        { id: 12719289763991, value: null },
        { id: 11132974899095, value: null },
        { id: 10899057188759, value: null },
        { id: 10900731766679, value: null },
        { id: 11172554846871, value: null },
        { id: 11616660009623, value: null },
        { id: 10895155905175, value: null },
        { id: 12148354172567, value: null },
        { id: 11132337387671, value: null },
      ],
      followup_ids: [],
      brand_id: 10485577125271,
      allow_channelback: false,
      allow_attachments: true,
    },
  ],
};

export const subjectActions = [
  { name: 'Pergunta', id: '1' },
  { name: 'Elogio', id: '2' },
  { name: 'Reclamação', id: '3' },
  { name: 'Solicitação', id: '4' },
  { name: 'Sugestão', id: '5' },
];

export const statusActions = [
  { name: 'Novo', id: '1' },
  { name: 'Aberto', id: '2' },
  { name: 'Pendente', id: '3' },
  { name: 'Em espera', id: '4' },
  { name: 'Resolvido', id: '5' },
  { name: 'Fechado', id: '6' },
];

export const mockListOfValuesResponse = [
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f313584b-6c3d-11ee-a7d1-dd819593d8cd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Como Funciona',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_como_funciona_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:06:22.200Z',
    updated_at: '2023-10-16T16:06:22.200Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '07ee173c-6c3e-11ee-9bf3-e5d3bcaee0bf',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Quem Pode Contratar',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_quem_pode_contratar_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:06:57.188Z',
    updated_at: '2023-10-16T16:06:57.188Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1d5a1933-6c3e-11ee-ae2a-eba79fa7b79b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Como Contratar',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_como_contratar_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:07:33.128Z',
    updated_at: '2023-10-16T16:07:33.128Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2dd28ecb-6c3e-11ee-a9a4-4b8cb154d581',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Valores::Para a Empresa',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_valores_para_a_empresa_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:08:00.761Z',
    updated_at: '2023-10-16T16:09:05.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '45fc03cb-6c3e-11ee-8ccf-634ee198744f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Valores::Para a Equipe',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_valores_para_a_equipe_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:08:41.298Z',
    updated_at: '2023-10-16T16:08:41.298Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '73fac40e-6c3e-11ee-8ccf-0fe1dc3773cb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Benefícios::Para a Empresa',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_beneficios_para_a_empresa_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:09:58.465Z',
    updated_at: '2023-10-16T16:09:58.465Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '85098606-6c3e-11ee-8ccf-cd08b5133bb4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Benefícios::Para a Equipe',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_beneficios_para_a_equipe_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:10:27.083Z',
    updated_at: '2023-10-16T16:10:27.083Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9dc6134a-6c3e-11ee-8ccf-859ac2de3c22',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::Formato Pagamento',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_formato_pagamento_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-16T16:11:08.584Z',
    updated_at: '2023-10-16T16:11:08.584Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fa7702b1-6c54-11ee-8ccf-4590e419ebdd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Clube Smiles Para Empresas::Gerenciamento do Benefício::Erro no Portal',
      tabulacao_tag: 'reclamacao_clube_smiles_para_empresas_gerenciamento_do_beneficio_erro_no_portal_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:51:13.022Z',
    updated_at: '2023-10-16T18:51:13.022Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2493f4a5-6c55-11ee-9bf3-19d64a704553',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento do Benefício::Não Consigo Acessar o Extrato',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_do_beneficio_nao_consigo_acessar_o_extrato_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:52:23.676Z',
    updated_at: '2023-10-16T18:54:04.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '778e0543-6c55-11ee-9bf3-013e8856bb9d',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento do Benefício::Não Consigo Gerenciar os Planos Disponíveis',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_do_beneficio_nao_consigo_gerenciar_os_planos_disponiveis_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:54:42.888Z',
    updated_at: '2023-10-16T18:54:42.888Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '91b03c49-6c55-11ee-9bf3-27af8060cd82',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento do Benefício::Minha Equipe Não Consegue Contratar',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_do_beneficio_minha_equipe_nao_consegue_contratar_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:55:26.733Z',
    updated_at: '2023-10-16T18:55:26.733Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ac985c26-6c55-11ee-a7d1-73aefa4502d5',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento do Benefício::Não Consigo Desativar o Benefício',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_do_beneficio_nao_consigo_desativar_o_beneficio_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:56:11.875Z',
    updated_at: '2023-10-16T18:56:11.875Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c5760583-6c55-11ee-8ccf-839de0022172',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Erro no Portal',
      tabulacao_tag: 'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_erro_no_portal_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:56:53.593Z',
    updated_at: '2023-10-16T18:56:53.593Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'dbb0c8e0-6c55-11ee-a7d1-ff138c871435',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Não Consigo Gerenciar a Equipe',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_nao_consigo_gerenciar_a_equipe_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:57:30.888Z',
    updated_at: '2023-10-16T18:57:30.888Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f37f25be-6c55-11ee-a9a4-45c481eb90a7',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Não Consigo Cadastrar Novas Pessoas',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_nao_consigo_cadastrar_novas_pessoas_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:58:10.828Z',
    updated_at: '2023-10-16T18:58:10.828Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '09946015-6c56-11ee-a7d1-bd6c05d77cad',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Não Consigo Subir Arquivo de Equipe',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_nao_consigo_subir_arquivo_de_equipe_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:58:47.877Z',
    updated_at: '2023-10-16T18:58:47.877Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '27f79c17-6c56-11ee-a9a4-c79cca952d2d',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Não Consigo Editar Dados de Equipe',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_nao_consigo_editar_dados_de_equipe_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T18:59:38.859Z',
    updated_at: '2023-10-16T18:59:38.859Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4f22c5cc-6c56-11ee-a7d1-b3e8544ecb2d',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Clube Smiles Para Empresas::Gerenciamento de Equipe::Não Consigo Desativar Pessoas da Equipe',
      tabulacao_tag:
        'reclamacao_clube_smiles_para_empresas_gerenciamento_de_equipe_nao_consigo_desativar_pessoas_da_equipe_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-10-16T19:00:44.573Z',
    updated_at: '2023-10-16T19:00:44.573Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6bdd33f6-6c56-11ee-a9a4-81d944d4740d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Clube Smiles Para Empresas::Cobrança',
      tabulacao_tag: 'reclamacao_clube_smiles_para_empresas_cobranca_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_comercial_clube_smiles_para_empresas',
    },
    created_at: '2023-10-16T19:01:32.771Z',
    updated_at: '2023-10-16T19:01:32.771Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '84497d34-6c56-11ee-a9e5-274368e89135',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Clube Smiles Para Empresas::Engajamento Equipe',
      tabulacao_tag: 'solicitacao_clube_smiles_para_empresas_engajamento_equipe_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_comercial_clube_smiles_para_empresas',
    },
    created_at: '2023-10-16T19:02:13.746Z',
    updated_at: '2023-10-16T19:02:13.746Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '958c2131-6c56-11ee-837d-df408e21ded6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Clube Smiles Para Empresas::Alteração Contrato Comercial',
      tabulacao_tag: 'solicitacao_clube_smiles_para_empresas_alteracao_contrato_comercial_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_comercial_clube_smiles_para_empresas',
    },
    created_at: '2023-10-16T19:02:42.704Z',
    updated_at: '2023-10-16T19:02:42.704Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a928baee-6c56-11ee-a9e5-b5f684eea73e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Clube Smiles Para Empresas::Contratação de Benefício::Formulário de Interesse',
      tabulacao_tag: 'solicitacao_clube_smiles_para_empresas_contratacao_de_beneficio_formulario_de_interesse_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_comercial_clube_smiles_para_empresas_solicitacao',
    },
    created_at: '2023-10-16T19:03:15.607Z',
    updated_at: '2023-10-19T18:48:00.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bef8aede-6c56-11ee-a7d1-89b0d38089e0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Clube Smiles Para Empresas',
      tabulacao_tag: 'sugestao_clube_smiles_para_empresas_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-10-16T19:03:52.202Z',
    updated_at: '2023-10-16T19:03:52.202Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3af49faa-773b-11ee-8369-d75349a1ace5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Clube Smiles Para Empresas::O Que é',
      tabulacao_tag: 'informacao_clube_smiles_para_empresas_o_que_e_voebiz',
      tabulacao_sla: 'sla_imediato',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-10-30T15:44:37.095Z',
    updated_at: '2023-10-30T15:44:37.095Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8d1e9267-773f-11ee-9e07-459d55e5220a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Clube Smiles Para Empresas::Novos Benefícios',
      tabulacao_tag: 'sugestao_clube_smiles_para_empresas_novos_beneficios_voebiz',
      tabulacao_sla: 'sla_imediato',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-10-30T16:15:32.930Z',
    updated_at: '2023-10-30T16:15:32.930Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a8aa6c6b-773f-11ee-bd0c-1f7a5c47714c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Clube Smiles Para Empresas::Valores',
      tabulacao_tag: 'sugestao_clube_smiles_para_empresas_valores_voebiz',
      tabulacao_sla: 'sla_imediato',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-10-30T16:16:19.145Z',
    updated_at: '2023-10-30T16:16:19.145Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b71c8aa5-773f-11ee-acbd-559794057a10',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Clube Smiles Para Empresas::Planos Disponíveis',
      tabulacao_tag: 'sugestao_clube_smiles_para_empresas_planos_disponiveis_voebiz',
      tabulacao_sla: 'sla_imediato',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-10-30T16:16:43.381Z',
    updated_at: '2023-10-30T16:16:43.381Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3039cacc-7740-11ee-bd0c-739d7cb97a92',
    external_id: null,
    attributes: {
      tabulacao_value: 'Elogio::Clube Smiles Para Empresa::Benefício',
      tabulacao_tag: 'elogio_clube_smiles_para_empresa_beneficio_voebiz',
      tabulacao_sla: 'sla_imediato',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_elogio',
    },
    created_at: '2023-10-30T16:20:06.577Z',
    updated_at: '2023-10-30T16:20:06.577Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4570e35e-7fce-11ed-8981-11101f0c4ec5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Elogio::Atendimento::Colaborador',
      tabulacao_tag: 'elogio_atendimento_colaborador_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_elogio',
    },
    created_at: '2022-12-19T18:52:22.337Z',
    updated_at: '2022-12-19T18:52:22.337Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '296577b6-805e-11ed-a27c-99f412bac8e0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Elogio::Atendimento::Programa VoeBiz',
      tabulacao_tag: 'elogio_atendimento_programa_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_elogio',
    },
    created_at: '2022-12-20T12:02:22.815Z',
    updated_at: '2022-12-20T12:02:22.815Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5091159e-805e-11ed-adda-0bd31ec774e2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Account Code Prime - Inclusão de Agência',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_account_code_prime_inclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:03:28.532Z',
    updated_at: '2022-12-20T12:03:28.532Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '671e3f85-805e-11ed-abe6-bb4b05724e8e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Account Code Prime - Exclusão de Agência',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_account_code_prime_exclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:04:06.367Z',
    updated_at: '2022-12-20T12:04:06.367Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7d6d2793-805e-11ed-b44c-1dc96500dc68',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Account Code - Regulamento de Parceira',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_account_code_regulamento_de_parceira_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:04:43.794Z',
    updated_at: '2022-12-20T12:04:43.794Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8a0c0c83-805e-11ed-8981-931d61dbe6f7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Incluir Número VoeBiz',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_incluir_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:05:04.968Z',
    updated_at: '2022-12-20T12:05:04.968Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9be8cdfd-805e-11ed-86ce-b35abb66346b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Status de Compra',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_status_de_compra_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:05:34.936Z',
    updated_at: '2022-12-20T12:05:34.936Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cfefbdf5-805e-11ed-86ce-8fbf21fe8911',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Regulamento - Pontos Retroativos - GOL',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_regulamento_pontos_retroativos_gol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:07:02.223Z',
    updated_at: '2022-12-20T12:07:02.223Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'da778389-805e-11ed-b44c-09b934e6bd66',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Erro Para Solicitar Crédito de Voo',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_erro_para_solicitar_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:07:19.890Z',
    updated_at: '2022-12-20T12:07:19.890Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e8694e53-805e-11ed-abe6-c762d75c4b31',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Regra de Acúmulo',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:07:43.285Z',
    updated_at: '2022-12-20T12:07:43.285Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '310653ad-805f-11ed-8981-4735354af7c5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Acúmulo::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_acumulo_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:09:45.110Z',
    updated_at: '2022-12-20T12:09:45.110Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4db8fa3f-805f-11ed-b44c-613246694ad9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Status da Compra',
      tabulacao_tag: 'informacao_aereas_gol_emissao_status_da_compra_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:10:33.257Z',
    updated_at: '2022-12-20T12:10:33.257Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '91c9726b-805f-11ed-abe6-f910c30eafcc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Consultar PNR',
      tabulacao_tag: 'informacao_aereas_gol_emissao_consultar_pnr_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:12:27.450Z',
    updated_at: '2022-12-20T12:12:27.450Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9f668d76-805f-11ed-b44c-0dfb1309d4bb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Como Utilizar',
      tabulacao_tag: 'informacao_aereas_gol_emissao_como_utilizar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:12:50.290Z',
    updated_at: '2022-12-20T12:12:50.290Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b5563e57-805f-11ed-a27c-fb6115c7c1ec',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'informacao_aereas_gol_emissao_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:13:27.093Z',
    updated_at: '2022-12-20T12:13:27.093Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c3c5c55d-805f-11ed-abe6-ad70359f317b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Token VoeBiz',
      tabulacao_tag: 'informacao_aereas_gol_emissao_token_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_taxa de embarque com pontos',
    },
    created_at: '2022-12-20T12:13:51.312Z',
    updated_at: '2022-12-28T18:55:34.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '01979401-8060-11ed-abe6-5fb337840253',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Emissão::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:15:35.028Z',
    updated_at: '2022-12-20T12:15:35.028Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '11596384-8060-11ed-adda-fd9f79026693',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Alteração Involuntária::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_alteracao_involuntaria_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:16:01.464Z',
    updated_at: '2022-12-20T12:16:01.464Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1a78e70f-8060-11ed-8981-e5ef175b90d1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Alteração Involuntária::Revalidação de Pontos Cancel Invol.',
      tabulacao_tag: 'informacao_aereas_gol_alteracao_involuntaria_revalidacao_de_pontos_cancel_invol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:16:16.770Z',
    updated_at: '2022-12-20T12:16:16.770Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2472c354-8060-11ed-adda-437ffe425837',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Antecipação Voluntária::Antecipação de Voo - 06 Horas',
      tabulacao_tag: 'informacao_aereas_gol_antecipacao_voluntaria_antecipacao_de_voo_06_horas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:16:33.507Z',
    updated_at: '2022-12-20T12:16:33.507Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '838e7355-8060-11ed-adda-170ad8d96890',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Antecipação Voluntária::Antecipação de Voo - Mesmo Dia',
      tabulacao_tag: 'informacao_aereas_gol_antecipacao_voluntaria_antecipacao_de_voo_mesmo_dia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:19:13.072Z',
    updated_at: '2022-12-20T12:19:13.072Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9a77792f-8060-11ed-b44c-974c9840367e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:19:51.509Z',
    updated_at: '2022-12-20T12:19:51.509Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ac32cf1c-8060-11ed-adda-6f21990592fd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_regulamento',
    },
    created_at: '2022-12-20T12:20:21.258Z',
    updated_at: '2023-02-01T13:28:00.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c3fdcfeb-8060-11ed-a27c-f7897ac02fc5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:21:01.176Z',
    updated_at: '2022-12-26T13:17:57.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e7f5bac9-8060-11ed-a27c-ab1c97c435a7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Alteração Malha Aérea GOL::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_alteracao_malha_aerea_gol_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:22:01.521Z',
    updated_at: '2022-12-20T12:22:01.521Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f519fcd2-8060-11ed-a27c-cb2ea18712ec',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Reembolso::Reembolso Pontos',
      tabulacao_tag: 'informacao_aereas_gol_reembolso_reembolso_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:22:23.569Z',
    updated_at: '2022-12-20T12:22:23.569Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '00a1f3b6-8061-11ed-b44c-8f2cb773da6f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Reembolso::Reembolso Taxa de Embarque R$',
      tabulacao_tag: 'informacao_aereas_gol_reembolso_reembolso_taxa_de_embarque_r_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:22:42.915Z',
    updated_at: '2022-12-20T12:22:42.915Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1a3dbcd8-8061-11ed-adda-8fa1ed49dbf8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Reembolso::Reembolso Taxa de Embarque Pontos',
      tabulacao_tag: 'informacao_aereas_gol_reembolso_reembolso_taxa_de_embarque_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:23:25.879Z',
    updated_at: '2022-12-20T12:23:25.879Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '235f3b04-8061-11ed-a27c-25f44b819a60',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'informacao_aereas_gol_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:23:41.198Z',
    updated_at: '2022-12-20T12:23:41.198Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2ce7b8c8-8061-11ed-8981-13f3510ce123',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Meus Voos::Como Utilizar',
      tabulacao_tag: 'informacao_aereas_gol_meus_voos_como_utilizar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-20T12:23:57.192Z',
    updated_at: '2022-12-20T12:23:57.192Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a159a1b1-82c4-11ed-8981-cf5f972b4688',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Meus Voos::Serviço Indisponível',
      tabulacao_tag: 'informacao_aereas_gol_meus_voos_servico_indisponivel_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:20:55.056Z',
    updated_at: '2022-12-23T13:20:55.056Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b0631e82-82c4-11ed-8981-234804af2f9a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Não Comparecimento ao Embarque::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_nao_comparecimento_ao_embarque_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:21:20.284Z',
    updated_at: '2022-12-23T13:21:20.284Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c22ca4f7-82c4-11ed-a27c-7b197ee7ebdf',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Check In::Check in Celular',
      tabulacao_tag: 'informacao_aereas_gol_check_in_check_in_celular_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:21:50.126Z',
    updated_at: '2022-12-23T13:21:50.126Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cd377ce8-82c4-11ed-abe6-5df794e0c6df',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Check In::Check-in Prioritário',
      tabulacao_tag: 'informacao_aereas_gol_check_in_checkin_prioritario_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:22:08.652Z',
    updated_at: '2022-12-23T13:22:08.652Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e0a84bc9-82c4-11ed-adda-a71e819746bd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Check In::Check in on Line',
      tabulacao_tag: 'informacao_aereas_gol_check_in_check_in_on_line_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:22:41.268Z',
    updated_at: '2022-12-23T13:22:41.268Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'eeac66df-82c4-11ed-8981-171145492e50',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Check In::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_check_in_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:23:04.783Z',
    updated_at: '2022-12-23T13:23:04.783Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bceafc09-82c8-11ed-a27c-15d6457b7cd3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Account Code Prime - Inclusão de Agência',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_account_code_prime_inclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:50:19.294Z',
    updated_at: '2022-12-23T13:50:19.294Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cb2fc949-82c8-11ed-a27c-0741c160c525',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Account Code Prime - Exclusão de Agência',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_account_code_prime_exclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:50:43.233Z',
    updated_at: '2022-12-23T13:50:43.233Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'da3fd63b-82c8-11ed-86ce-11a94b0a6520',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Account Code - Regulamento de Parceira',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_account_code_regulamento_de_parceira_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-23T13:51:08.504Z',
    updated_at: '2022-12-23T13:51:08.504Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fda0a1e8-851a-11ed-b44c-5f8bc8d7259f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Incluir Número VoeBiz',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_incluir_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:44:08.916Z',
    updated_at: '2022-12-26T12:44:08.916Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0f941f5c-851b-11ed-a364-01916edf1d88',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Status de Compra',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_status_de_compra_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:44:39.033Z',
    updated_at: '2022-12-26T12:44:39.033Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2fa9edd6-851b-11ed-adda-43936f930e72',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Regulamento - Pontos Retroativos - Parceiras',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_regulamento_pontos_retroativos_parceiras_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:45:32.863Z',
    updated_at: '2022-12-26T12:45:32.863Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ee8889af-851b-11ed-adda-5148d2717991',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Erro Para Solicitar Crédito de Voo',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_erro_para_solicitar_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:50:53.089Z',
    updated_at: '2022-12-26T12:50:53.089Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ffc64bb0-851b-11ed-adda-53e27df51c0f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Regra de Acúmulo',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:51:22.015Z',
    updated_at: '2022-12-26T12:51:22.015Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '472a3417-851c-11ed-8981-bf1c103a36d2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Acúmulo::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_acumulo_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:53:21.788Z',
    updated_at: '2022-12-26T12:53:21.788Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7ec7b872-851c-11ed-adda-bbb23b5fde84',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Status da Compra',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_status_da_compra_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:54:55.095Z',
    updated_at: '2022-12-26T12:54:55.095Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a1e792ee-851c-11ed-814b-eb880b939945',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Consultar PNR',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_consultar_pnr_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:55:54.024Z',
    updated_at: '2022-12-26T12:55:54.024Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b12dca4b-851c-11ed-a27c-370051137487',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Como Utilizar',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_como_utilizar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:56:19.650Z',
    updated_at: '2022-12-26T12:56:19.650Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bcc72707-851c-11ed-b44c-bd27909ab5b6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T12:56:39.110Z',
    updated_at: '2022-12-26T12:56:39.110Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3d9f5001-851d-11ed-8981-1bc65f36500f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Token VoeBiz',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_token_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:00:15.275Z',
    updated_at: '2022-12-26T13:00:15.275Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4a28d874-851d-11ed-b44c-cf330e6c36a1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Emissão::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:00:36.309Z',
    updated_at: '2022-12-26T13:00:36.309Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8578b70a-851d-11ed-814b-b592a52b6513',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Alteração Involuntária::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_alteracao_involuntaria_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:02:15.818Z',
    updated_at: '2022-12-26T13:02:15.818Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8ee4ac09-851d-11ed-adda-99c4657a9fda',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Alteração Involuntária::Revalidação de Pontos Cancel Invol.',
      tabulacao_tag: 'informacao_aereas_parceiras_alteracao_involuntaria_revalidacao_de_pontos_cancel_invol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:02:31.625Z',
    updated_at: '2022-12-26T13:02:31.625Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9ee09f87-851d-11ed-a27c-6f34cdac1cb1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Antecipação Voluntária::Antecipação de Voo - 06 Horas',
      tabulacao_tag: 'informacao_aereas_parceiras_antecipacao_voluntaria_antecipacao_de_voo_06_horas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:02:58.442Z',
    updated_at: '2022-12-26T13:02:58.442Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fdabbd96-851d-11ed-a27c-abb494fd9b16',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Antecipação Voluntária::Antecipação de Voo - 06 Horas',
      tabulacao_tag: 'informacao_aereas_parceiras_antecipacao_voluntaria_antecipacao_de_voo_06_horas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:05:37.479Z',
    updated_at: '2022-12-26T13:05:37.479Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '09f9012e-851e-11ed-814b-0105dc4fd971',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Antecipação Voluntária::Antecipação de Voo - Mesmo Dia',
      tabulacao_tag: 'informacao_aereas_parceiras_antecipacao_voluntaria_antecipacao_de_voo_mesmo_dia_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:05:58.118Z',
    updated_at: '2022-12-26T13:05:58.118Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '64b3c801-851e-11ed-adda-257d5b4711f1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:08:30.337Z',
    updated_at: '2022-12-26T13:08:30.337Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '75517955-851e-11ed-adda-b9b4f88ec883',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:08:58.214Z',
    updated_at: '2022-12-26T13:08:58.214Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a9e95ed6-851e-11ed-8981-81a505014692',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:10:26.451Z',
    updated_at: '2022-12-26T13:10:26.451Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bc22493c-851e-11ed-a364-51a97b480c16',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Alteração Malha Aérea GOL::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_alteracao_malha_aerea_gol_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:10:57.023Z',
    updated_at: '2022-12-26T13:10:57.023Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e4402536-8520-11ed-adda-2d035fcfd0cd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Reembolso::Reembolso Pontos',
      tabulacao_tag: 'informacao_aereas_parceiras_reembolso_reembolso_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:26:23.321Z',
    updated_at: '2022-12-26T13:26:23.321Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f3bc3a07-8520-11ed-b44c-1fbcfed94767',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Reembolso::Reembolso Taxa de Embarque R$',
      tabulacao_tag: 'informacao_aereas_parceiras_reembolso_reembolso_taxa_de_embarque_r_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:26:49.300Z',
    updated_at: '2022-12-26T13:26:49.300Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '017da691-8521-11ed-814b-ef9304431508',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Reembolso::Reembolso Taxa de Embarque Pontos',
      tabulacao_tag: 'informacao_aereas_parceiras_reembolso_reembolso_taxa_de_embarque_pontos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:27:12.378Z',
    updated_at: '2022-12-26T13:27:12.378Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0aba7497-8521-11ed-a27c-6d4d5ac5afae',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'informacao_aereas_parceiras_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T13:27:27.876Z',
    updated_at: '2022-12-26T13:43:54.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '254793dd-8527-11ed-814b-87ae6e57d6d9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Meus Voos::Como Utilizar',
      tabulacao_tag: 'informacao_aereas_parceiras_meus_voos_como_utilizar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:11:09.402Z',
    updated_at: '2022-12-26T14:11:09.402Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3f4860e0-8527-11ed-8981-0d7bdfb8094f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Meus Voos::Serviço Indisponível',
      tabulacao_tag: 'informacao_aereas_parceiras_meus_voos_servico_indisponivel_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:11:53.028Z',
    updated_at: '2022-12-26T14:11:53.028Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6cca288c-8527-11ed-a364-0d7cdfe14cc9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Não Comparecimento ao Embarque::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_nao_comparecimento_ao_embarque_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:13:09.376Z',
    updated_at: '2022-12-26T14:13:09.376Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '81bc187f-8527-11ed-b44c-a7f1f4259680',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Check In::Check in Celular',
      tabulacao_tag: 'informacao_aereas_parceiras_check_in_check_in_celular_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:13:44.516Z',
    updated_at: '2022-12-26T14:13:44.516Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c61902e0-8527-11ed-adda-6b278a5baea4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Check In::Check-in Prioritário',
      tabulacao_tag: 'informacao_aereas_parceiras_check_in_checkin_prioritario_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:15:39.210Z',
    updated_at: '2022-12-26T14:15:39.210Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '090d0eca-8528-11ed-8981-8bb80476b5fc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Check In::Check in on Line',
      tabulacao_tag: 'informacao_aereas_parceiras_check_in_check_in_on_line_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:17:31.539Z',
    updated_at: '2022-12-26T14:17:31.539Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '805518c0-8528-11ed-a364-2f39668e97a9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - Parceiras::Check In::Regulamento',
      tabulacao_tag: 'informacao_aereas_parceiras_check_in_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:20:51.660Z',
    updated_at: '2022-12-26T14:20:51.660Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd713abb4-8528-11ed-814b-0f6390c3aaf5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Traslado Entre Aeroportos',
      tabulacao_tag: 'informacao_aeroporto_traslado_entre_aeroportos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:23:17.193Z',
    updated_at: '2022-12-26T14:23:17.193Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2e856268-8529-11ed-814b-edfbf31c27b9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Check In',
      tabulacao_tag: 'informacao_aeroporto_check_in_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:25:43.900Z',
    updated_at: '2022-12-26T14:25:43.900Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '82b7f32a-8529-11ed-8981-cf10f0a223ef',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Procedimento de Embarque',
      tabulacao_tag: 'informacao_aeroporto_procedimento_de_embarque_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:28:05.160Z',
    updated_at: '2022-12-26T14:28:05.160Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '01950f62-852a-11ed-adda-b93619f58e0f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Sala VIP',
      tabulacao_tag: 'informacao_aeroporto_sala_vip_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:31:38.002Z',
    updated_at: '2022-12-26T14:31:38.002Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '08ed6687-852a-11ed-a27c-d33fc55d38b7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Serviço de Bordo',
      tabulacao_tag: 'informacao_aeroporto_servico_de_bordo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:31:50.325Z',
    updated_at: '2022-12-26T14:31:50.325Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '10437470-852a-11ed-a364-bb9bfb775cda',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Aeronave Max',
      tabulacao_tag: 'informacao_aeroporto_aeronave_max_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:32:02.633Z',
    updated_at: '2022-12-26T14:32:02.633Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1ea2a6d7-852a-11ed-a27c-a9bf48c7c19e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Excesso de Bagagem - Diferenciado',
      tabulacao_tag: 'informacao_aeroporto_excesso_de_bagagem_diferenciado_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:32:26.745Z',
    updated_at: '2022-12-26T14:32:26.745Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2d8e897c-852a-11ed-a27c-01f84b20b1ed',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Franquia de Bagagem - Parceiras',
      tabulacao_tag: 'informacao_aeroporto_franquia_de_bagagem_parceiras_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:32:51.779Z',
    updated_at: '2022-12-26T14:32:51.779Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7a138198-852b-11ed-814b-414b4c5db2ca',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Franquia de Bagagem - GOL',
      tabulacao_tag: 'informacao_aeroporto_franquia_de_bagagem_gol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:42:09.654Z',
    updated_at: '2022-12-26T14:42:09.654Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8636f625-852b-11ed-a27c-1fd022aab67b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Transporte de Animais',
      tabulacao_tag: 'informacao_aeroporto_transporte_de_animais_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:42:30.019Z',
    updated_at: '2022-12-26T14:42:30.019Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8f3c12f1-852b-11ed-adda-2faa657c2243',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Bagagens Especiais',
      tabulacao_tag: 'informacao_aeroporto_bagagens_especiais_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:42:45.152Z',
    updated_at: '2022-12-26T14:42:45.152Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '969e5536-852b-11ed-adda-9fb1276d18ba',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Utilização de Máscara',
      tabulacao_tag: 'informacao_aeroporto_utilizacao_de_mascara_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:42:57.540Z',
    updated_at: '2022-12-26T14:42:57.540Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3edd50e2-852c-11ed-a27c-d753c66e696d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Fornecimento de Máscara',
      tabulacao_tag: 'informacao_aeroporto_fornecimento_de_mascara_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:47:39.810Z',
    updated_at: '2022-12-26T14:47:39.810Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '477d42e6-852c-11ed-a364-95a2e2ae4997',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aeroporto::Serviços Especiais',
      tabulacao_tag: 'informacao_aeroporto_servicos_especiais_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:47:54.280Z',
    updated_at: '2022-12-26T14:48:13.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '085a4721-852d-11ed-adda-0316fda2fdc4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Atendimento::Contato Interrompido',
      tabulacao_tag: 'informacao_atendimento_contato_interrompido_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:53:17.851Z',
    updated_at: '2022-12-26T14:53:17.851Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '14f7099b-852d-11ed-a27c-33826082e427',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Atendimento::Sem Interação do Cliente',
      tabulacao_tag: 'informacao_atendimento_sem_interacao_do_cliente_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:53:39.011Z',
    updated_at: '2022-12-26T14:54:32.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '40f713da-852d-11ed-814b-2d95340a10ee',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Atendimento::Sistema Inoperante',
      tabulacao_tag: 'informacao_atendimento_sistema_inoperante_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:54:52.831Z',
    updated_at: '2022-12-26T14:54:52.831Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4a8424bf-852d-11ed-a364-d9adef2e0e5c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Atendimento::Telefone de Outra Área',
      tabulacao_tag: 'informacao_atendimento_telefone_de_outra_area_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:55:08.855Z',
    updated_at: '2022-12-26T14:55:08.855Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5cf8dffd-852d-11ed-814b-6d8363ae3531',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Atendimento::Status Atendimento',
      tabulacao_tag: 'informacao_atendimento_status_atendimento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:55:39.819Z',
    updated_at: '2022-12-26T14:55:39.819Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'eaf9431f-852d-11ed-b44c-03418df7e6b5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Cadastro::Benefícios',
      tabulacao_tag: 'informacao_conta_voebiz_cadastro_beneficios_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-26T14:59:38.058Z',
    updated_at: '2022-12-26T14:59:38.058Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '82c67d7b-85e3-11ed-adda-4b109616fbad',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Cadastro::Status da Conta',
      tabulacao_tag: 'informacao_conta_voebiz_cadastro_status_da_conta_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:39:31.647Z',
    updated_at: '2022-12-27T12:39:31.647Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '910cf866-85e3-11ed-adda-37d32b85ee17',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Cadastro::Status de Cadastro',
      tabulacao_tag: 'informacao_conta_voebiz_cadastro_status_de_cadastro_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:39:55.597Z',
    updated_at: '2022-12-27T12:39:55.597Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a0822ec7-85e3-11ed-a27c-9b748c2971e8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Cadastro::Unificação de Contas',
      tabulacao_tag: 'informacao_conta_voebiz_cadastro_unificacao_de_contas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:40:21.531Z',
    updated_at: '2022-12-27T12:40:21.531Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'af34d93e-85e3-11ed-b44c-8b4089501788',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Portal Indisponível',
      tabulacao_tag: 'informacao_conta_voebiz_portal_indisponivel_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_unificacao de contas',
    },
    created_at: '2022-12-27T12:40:46.190Z',
    updated_at: '2022-12-27T13:01:30.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e539bcf8-85e3-11ed-8981-719ab4e47767',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Alteração Cadastral',
      tabulacao_tag: 'informacao_conta_voebiz_alteracao_cadastral_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:42:16.819Z',
    updated_at: '2022-12-27T12:42:16.819Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f1f0492c-85e3-11ed-814b-11f845c79726',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Categoria VoeBiz::Mudança de Categoria',
      tabulacao_tag: 'informacao_conta_voebiz_categoria_voebiz_mudanca_de_categoria_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:42:38.148Z',
    updated_at: '2022-12-27T12:42:38.148Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fb455a1e-85e3-11ed-adda-a553962d80c3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Alteração de Senha',
      tabulacao_tag: 'informacao_conta_voebiz_alteracao_de_senha_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:42:53.805Z',
    updated_at: '2022-12-27T12:43:35.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '215a4670-85e6-11ed-adda-8bf87e0dd5a9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Confirmação Envio de Senha',
      tabulacao_tag: 'informacao_conta_voebiz_confirmacao_envio_de_senha_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:58:16.689Z',
    updated_at: '2022-12-27T12:58:16.689Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2c5195f4-85e6-11ed-814b-d3711b100d27',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Novo Número VoeBiz',
      tabulacao_tag: 'informacao_conta_voebiz_novo_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:58:35.087Z',
    updated_at: '2022-12-27T12:58:35.087Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '363b94f0-85e6-11ed-adda-ed42a3e61dfc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Conta VoeBiz::Primeira Senha',
      tabulacao_tag: 'informacao_conta_voebiz_primeira_senha_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:58:51.720Z',
    updated_at: '2022-12-27T12:58:51.720Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '48025cfd-85e6-11ed-adda-6510d816a525',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Orientação Para Inscrição',
      tabulacao_tag: 'informacao_nao_cliente_orientacao_para_inscricao_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:59:21.544Z',
    updated_at: '2022-12-27T12:59:21.544Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '54e094eb-85e6-11ed-8981-7535cf0e896c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Orientação Para Acesso',
      tabulacao_tag: 'informacao_nao_cliente_orientacao_para_acesso_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:59:43.133Z',
    updated_at: '2022-12-27T12:59:43.133Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5d71e1b6-85e6-11ed-a364-59c4d1ad2ef1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Acúmulo',
      tabulacao_tag: 'informacao_nao_cliente_acumulo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T12:59:57.507Z',
    updated_at: '2022-12-27T12:59:57.507Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '67d4c414-85e7-11ed-a364-4560e39b1471',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Resgate',
      tabulacao_tag: 'informacao_nao_cliente_resgate_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:07:24.429Z',
    updated_at: '2022-12-27T13:07:24.429Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '78ef1f8e-85e7-11ed-adda-514921ee7895',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Categoria VoeBiz',
      tabulacao_tag: 'informacao_nao_cliente_categoria_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:07:53.123Z',
    updated_at: '2022-12-27T13:07:53.123Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '80836e75-85e7-11ed-a27c-7bff334f4784',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Parceiras Aéreas',
      tabulacao_tag: 'informacao_nao_cliente_parceiras_aereas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:08:05.839Z',
    updated_at: '2022-12-27T13:08:05.839Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c3d4b4da-85e7-11ed-8981-5d58603bbf93',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Validade de Pontos - Resgatáveis',
      tabulacao_tag: 'informacao_nao_cliente_validade_de_pontos_resgataveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:09:58.779Z',
    updated_at: '2022-12-27T13:09:58.779Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cb602a5b-85e7-11ed-a364-3f2d5352035d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Não Cliente::Validade de Pontos - Qualificáveis',
      tabulacao_tag: 'informacao_nao_cliente_validade_de_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:10:11.437Z',
    updated_at: '2022-12-27T13:10:11.437Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd61ce244-85e7-11ed-8981-cf7854db4ec3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Dúvidas',
      tabulacao_tag: 'informacao_extrato_duvidas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:10:29.451Z',
    updated_at: '2022-12-27T13:10:29.451Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'de5cb386-85e7-11ed-a364-61bf3321222f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Saldo Pontos Qualificáveis',
      tabulacao_tag: 'informacao_extrato_saldo_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:10:43.291Z',
    updated_at: '2022-12-27T13:10:43.291Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e5d0f730-85e7-11ed-a364-d7fdee1fc1d7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Saldo Pontos Resgatáveis',
      tabulacao_tag: 'informacao_extrato_saldo_pontos_resgataveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:10:55.797Z',
    updated_at: '2022-12-27T13:10:55.797Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ee05f2cf-85e7-11ed-adda-a74d7779f87c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Pontos Expirados',
      tabulacao_tag: 'informacao_extrato_pontos_expirados_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:11:09.566Z',
    updated_at: '2022-12-27T13:11:09.566Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f6a34c58-85e7-11ed-a364-8f4b73e28157',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Validade de Pontos - Qualificáveis',
      tabulacao_tag: 'informacao_extrato_validade_de_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:11:24.019Z',
    updated_at: '2022-12-27T13:11:24.019Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fd5ec81f-85e7-11ed-8981-f763176bd50c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Extrato::Validade de Pontos - Resgatáveis',
      tabulacao_tag: 'informacao_extrato_validade_de_pontos_resgataveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2022-12-27T13:11:35.314Z',
    updated_at: '2022-12-27T13:11:35.314Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '21a5bc4b-85e8-11ed-a364-715ac4f3de59',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Account Code Prime - Desconto Não Está Aplicando na Agência',
      tabulacao_tag: 'reclamacao_aereas_gol_account_code_prime_desconto_nao_esta_aplicando_na_agencia_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:12:36.177Z',
    updated_at: '2022-12-27T13:22:08.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9418c9ff-85e9-11ed-adda-97243f8bf740',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Account Code Prime - Desconto Não Está Aplicando no Site B2B',
      tabulacao_tag: 'reclamacao_aereas_gol_account_code_prime_desconto_nao_esta_aplicando_no_site_b2b_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:22:57.688Z',
    updated_at: '2022-12-27T13:22:57.688Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a4f3f9f6-85e9-11ed-8981-0f410b9b1f2e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Voo Acumulado em Outra Conta',
      tabulacao_tag: 'reclamacao_aereas_gol_voo_acumulado_em_outra_conta_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:23:25.968Z',
    updated_at: '2022-12-27T13:23:25.968Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cb19997d-85e9-11ed-a27c-13e21d9f06f1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Crédito de Voo Antes da Inscrição',
      tabulacao_tag: 'reclamacao_aereas_gol_credito_de_voo_antes_da_inscricao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:24:29.968Z',
    updated_at: '2022-12-27T13:24:29.968Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e1c435f8-85e9-11ed-a27c-35c33fe0a9b0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Crédito de Voo Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_credito_de_voo_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:25:07.996Z',
    updated_at: '2022-12-27T13:25:07.996Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f526301c-85ec-11ed-a27c-ab745984fb95',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Erro ao Incluir Número VoeBiz',
      tabulacao_tag: 'reclamacao_aereas_gol_erro_ao_incluir_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:47:09.005Z',
    updated_at: '2022-12-27T13:47:09.005Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0233b597-85ed-11ed-814b-b7e285734da4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Crédito de Vôo::Regra de Acúmulo',
      tabulacao_tag: 'reclamacao_aereas_gol_credito_de_voo_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:47:30.904Z',
    updated_at: '2022-12-28T17:11:39.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '18133a6f-85ed-11ed-adda-1de814ec1188',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:48:07.601Z',
    updated_at: '2022-12-27T13:48:07.601Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4b70cb70-85ed-11ed-814b-e1ebf701a1d4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Extensão de Pontos',
      tabulacao_tag: 'reclamacao_aereas_gol_extensao_de_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:49:33.778Z',
    updated_at: '2022-12-27T13:49:33.778Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5bd93bf7-85ed-11ed-8981-ebfeef61a71b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - GOL - Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_gol_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:50:01.306Z',
    updated_at: '2022-12-27T13:50:01.306Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6698b36b-85ed-11ed-adda-13aeecd1ff9a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - GOL - Erro no Site',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_gol_erro_no_site_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:50:19.338Z',
    updated_at: '2022-12-27T13:50:19.338Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7325be29-85ed-11ed-b44c-973133ca1ae4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - GOL - Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_gol_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:50:40.395Z',
    updated_at: '2022-12-27T13:50:40.395Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '81a96990-85ed-11ed-a27c-0ba165dfa258',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - Parceiras - Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_parceiras_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:51:04.746Z',
    updated_at: '2022-12-27T13:51:04.746Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8e88da18-85ed-11ed-b44c-d7483c03e0dc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - Parceiras - Erro no Site',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_parceiras_erro_no_site_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:51:26.343Z',
    updated_at: '2022-12-27T13:51:26.343Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9ae2792a-85ed-11ed-b44c-19e9e5af121b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Pontos Retroativos - Parceiras - Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_pontos_retroativos_parceiras_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T13:51:47.063Z',
    updated_at: '2022-12-27T13:51:47.063Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4b88b911-85f0-11ed-814b-d523e432f280',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Promoção Indísponível',
      tabulacao_tag: 'reclamacao_aereas_gol_promocao_indisponivel_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:11:02.425Z',
    updated_at: '2022-12-27T14:11:02.425Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '561deb56-85f0-11ed-a27c-0196767fb63a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Promoções',
      tabulacao_tag: 'reclamacao_aereas_gol_promocoes_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:11:20.180Z',
    updated_at: '2022-12-27T14:11:20.180Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '683e6cd3-85f0-11ed-8981-65c87e26cce0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Procedimento de Embarque',
      tabulacao_tag: 'reclamacao_aeroporto_procedimento_de_embarque_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:11:50.592Z',
    updated_at: '2022-12-27T14:11:50.592Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '74ebd14b-85f0-11ed-814b-617aaefe11b2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Cobrança de Taxa de Acomp. Menor',
      tabulacao_tag: 'reclamacao_aeroporto_cobranca_de_taxa_de_acomp_menor_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:12:11.861Z',
    updated_at: '2023-01-30T19:37:48.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8aece6a3-85f0-11ed-a364-9b191e566145',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Isenção Taxa Laudo Médico',
      tabulacao_tag: 'reclamacao_aeroporto_isencao_taxa_laudo_medico_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:12:48.778Z',
    updated_at: '2022-12-27T14:12:48.778Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '98e7b2a0-85f0-11ed-a364-f7c22d517be3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Traslado Entre Aeroportos',
      tabulacao_tag: 'reclamacao_aeroporto_traslado_entre_aeroportos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:13:12.232Z',
    updated_at: '2022-12-27T14:13:12.232Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a590350b-85f0-11ed-a364-ad884faaadb6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Máscara - Cliente Não Concorda Com o Uso',
      tabulacao_tag: 'reclamacao_aeroporto_mascara_cliente_nao_concorda_com_o_uso_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:13:33.469Z',
    updated_at: '2022-12-27T14:13:33.469Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b1379b2d-85f0-11ed-814b-19d16ce73ced',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aeroporto::Fornecimento de Máscara',
      tabulacao_tag: 'reclamacao_aeroporto_fornecimento_de_mascara_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:13:53.021Z',
    updated_at: '2022-12-27T14:13:53.021Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3303731f-85f1-11ed-adda-7b82b69b7abc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Demora Para Atendimento',
      tabulacao_tag: 'reclamacao_atendimento_demora_para_atendimento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:17:30.783Z',
    updated_at: '2022-12-27T14:17:30.783Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '41ee92a7-85f1-11ed-a27c-b3563d214126',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Mau Atendimento',
      tabulacao_tag: 'reclamacao_atendimento_mau_atendimento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:17:55.812Z',
    updated_at: '2022-12-27T14:17:55.812Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5741dc9a-85f1-11ed-a364-2b1ac562770e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Demora na Ativação do Cadastro',
      tabulacao_tag: 'reclamacao_atendimento_demora_na_ativacao_do_cadastro_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T14:18:31.590Z',
    updated_at: '2022-12-27T14:18:31.590Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '06b4b1b0-860f-11ed-a27c-c129642aba5e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Demora no Atendimento BackOffice',
      tabulacao_tag: 'reclamacao_atendimento_demora_no_atendimento_backoffice_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T17:51:01.349Z',
    updated_at: '2022-12-27T17:51:01.349Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd921b67e-860f-11ed-b44c-b7c433872782',
    external_id: null,
    attributes: {
      tabulacao_value: 'Atendimento::Atendimento::Solicitação Atrasada',
      tabulacao_tag: 'atendimento_atendimento_solicitacao_atrasada_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_atendimento',
    },
    created_at: '2022-12-27T17:56:54.385Z',
    updated_at: '2022-12-27T17:56:54.385Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '20af95c0-8610-11ed-814b-3bdad4e9d013',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Erro Operacional',
      tabulacao_tag: 'reclamacao_atendimento_erro_operacional_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T17:58:54.433Z',
    updated_at: '2022-12-27T17:58:54.433Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e6551e76-8610-11ed-8981-6f8da7a21444',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Acesso a Conta::Mensagem de Erro',
      tabulacao_tag: 'reclamacao_conta_voebiz_acesso_a_conta_mensagem_de_erro_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-27T18:04:26.029Z',
    updated_at: '2022-12-27T18:47:14.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd72be793-8614-11ed-a364-91b18e898364',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T18:32:38.580Z',
    updated_at: '2022-12-27T18:32:38.580Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bb63255b-8617-11ed-b44c-1331a322bdef',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha::Senha Bloqueada',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_senha_bloqueada_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_conta voebiz',
    },
    created_at: '2022-12-27T18:53:20.456Z',
    updated_at: '2023-01-30T19:42:21.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1334d570-8618-11ed-a27c-ed1e1a2e86f7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha::Senha Não Recebida',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_senha_nao_recebida_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-27T18:55:47.792Z',
    updated_at: '2023-01-31T17:30:01.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7012cabb-8618-11ed-8981-b569f4b0d32b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Conta Reclamação::Conta VoeBiz::Senha::Mensagem de Erro Senha',
      tabulacao_tag: 'conta_reclamacao_conta_voebiz_senha_mensagem_de_erro_senha_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_conta voebiz',
    },
    created_at: '2022-12-27T18:58:23.597Z',
    updated_at: '2023-01-30T19:43:40.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4fe4ffc3-861b-11ed-a27c-213b1d0eb108',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha::Prazo de Pedido de Senha',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_prazo_de_pedido_de_senha_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_conta voebiz',
    },
    created_at: '2022-12-27T19:18:58.100Z',
    updated_at: '2023-01-30T19:44:05.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '830dc5aa-861b-11ed-a364-316363d4f033',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha::Senha Não Reconhecida',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_senha_nao_reconhecida_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_conta voebiz',
    },
    created_at: '2022-12-27T19:20:23.931Z',
    updated_at: '2023-01-30T19:44:32.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '460c67ee-86a4-11ed-814b-3bf621d1de40',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Inscrição::Dados Incorretos',
      tabulacao_tag: 'reclamacao_conta_voebiz_inscricao_dados_incorretos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:39:22.633Z',
    updated_at: '2022-12-28T11:51:48.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '584f16b8-86a4-11ed-814b-8b74fbb982fc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Inscrição::Inscrição',
      tabulacao_tag: 'reclamacao_conta_voebiz_inscricao_inscricao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:39:53.269Z',
    updated_at: '2022-12-28T11:53:07.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6ed0a836-86a4-11ed-8981-03ae3177798b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Inscrição::Duplicidade de Conta',
      tabulacao_tag: 'reclamacao_conta_voebiz_inscricao_duplicidade_de_conta_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:40:31.028Z',
    updated_at: '2022-12-28T11:53:55.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9390c4be-86a4-11ed-a27c-cd7ace7216db',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Inscrição::Aquisição de Empresa',
      tabulacao_tag: 'reclamacao_conta_voebiz_inscricao_aquisicao_de_empresa_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:41:32.685Z',
    updated_at: '2022-12-28T11:54:36.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a70cdd43-86a4-11ed-a364-5334a807ff05',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Inscrição::Regulamento',
      tabulacao_tag: 'reclamacao_conta_voebiz_inscricao_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:42:05.375Z',
    updated_at: '2022-12-28T11:56:31.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '860f51b2-86a5-11ed-814b-cb1fd987c1e4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Atualização Cadastral',
      tabulacao_tag: 'reclamacao_conta_voebiz_atualizacao_cadastral_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:48:19.523Z',
    updated_at: '2022-12-28T11:57:28.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c511d831-86a5-11ed-adda-17b4e3c0c979',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Cancelamento de Conta::Não Utiliza',
      tabulacao_tag: 'reclamacao_conta_voebiz_cancelamento_de_conta_nao_utiliza_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_conta voebiz',
    },
    created_at: '2022-12-28T11:50:05.236Z',
    updated_at: '2022-12-28T11:59:52.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4b85beab-86a7-11ed-814b-6f598249f363',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Cancelamento de Conta::Insatisfeito',
      tabulacao_tag: 'reclamacao_conta_voebiz_cancelamento_de_conta_insatisfeito_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:01:00.307Z',
    updated_at: '2022-12-28T12:01:00.307Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '638d53ae-86a7-11ed-b44c-e12b7cd5915f',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Conta VoeBiz::Cancelamento de Conta::Não Tem Mais Interesse em Participar do Programa',
      tabulacao_tag:
        'reclamacao_conta_voebiz_cancelamento_de_conta_nao_tem_mais_interesse_em_participar_do_programa_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:01:40.622Z',
    updated_at: '2022-12-28T12:01:40.622Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8b83bbe8-86a7-11ed-814b-d9ccca27bdd6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Cancelamento de Conta::Migração Para Acordo Corporativo',
      tabulacao_tag: 'reclamacao_conta_voebiz_cancelamento_de_conta_migracao_para_acordo_corporativo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:02:47.668Z',
    updated_at: '2022-12-28T12:02:47.668Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a3d50401-86a7-11ed-8981-432a3f8fcd14',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Cancelamento de Conta::Outros',
      tabulacao_tag: 'reclamacao_conta_voebiz_cancelamento_de_conta_outros_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:03:28.466Z',
    updated_at: '2022-12-28T12:03:28.466Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '71d07d51-86a8-11ed-8981-273d239dbd35',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Não Concorda Com Saldo',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_nao_concorda_com_saldo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:09:14.047Z',
    updated_at: '2022-12-28T12:09:14.047Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2f0b7bfc-86a9-11ed-a27c-4989c4153065',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Acúmulo Não Processado',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_acumulo_nao_processado_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:14:31.523Z',
    updated_at: '2022-12-28T12:14:31.523Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7e02a1ae-86a9-11ed-814b-bddcc3dff4af',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Resgate Não Processado',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_resgate_nao_processado_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:16:44.005Z',
    updated_at: '2022-12-28T12:16:44.005Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c12b9ff0-86a9-11ed-a27c-addc9f088a63',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Extrato Indisponível no Site',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_extrato_indisponivel_no_site_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:18:36.681Z',
    updated_at: '2022-12-28T12:18:36.681Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2acf6327-86aa-11ed-a364-3ffd8ada99a6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Cobrança Duplicada',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_cobranca_duplicada_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:21:33.915Z',
    updated_at: '2022-12-28T12:21:33.915Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '409397ec-86aa-11ed-a27c-0577219ef2ea',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Prorrogar Validade Dos Pontos',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_prorrogar_validade_dos_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:22:10.433Z',
    updated_at: '2022-12-28T12:22:10.433Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '73ed7f39-86aa-11ed-814b-19a815fd0f4e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Solicitação de Extrato Legado',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_solicitacao_de_extrato_legado_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:23:36.586Z',
    updated_at: '2022-12-28T12:23:36.586Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '93c58195-86aa-11ed-a364-3760e7da57c5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Extrato / Saldo::Saldo de Pontos',
      tabulacao_tag: 'reclamacao_conta_voebiz_extrato_saldo_saldo_de_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:24:30.011Z',
    updated_at: '2022-12-28T12:24:30.011Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cd15984d-86aa-11ed-a27c-6d0c4a6a749d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Categoria - VoeBiz::Regulamento',
      tabulacao_tag: 'reclamacao_conta_voebiz_categoria_voebiz_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:26:06.166Z',
    updated_at: '2022-12-28T12:26:58.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0a49c701-86ab-11ed-b44c-f33ab5ff1691',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Categoria - VoeBiz::Saldo de Pontos Qualificáveis',
      tabulacao_tag: 'reclamacao_conta_voebiz_categoria_voebiz_saldo_de_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:27:48.849Z',
    updated_at: '2022-12-28T12:27:48.849Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2f9aff51-86ab-11ed-814b-356474e8ad68',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Categoria - VoeBiz::Benefícios da Categoria',
      tabulacao_tag: 'reclamacao_conta_voebiz_categoria_voebiz_beneficios_da_categoria_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:28:51.457Z',
    updated_at: '2022-12-28T12:28:51.457Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3effe316-86ab-11ed-adda-7310c04fab44',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Conta Suspensa',
      tabulacao_tag: 'reclamacao_conta_voebiz_conta_suspensa_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:29:17.284Z',
    updated_at: '2022-12-28T12:29:17.284Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7ba2801a-86ab-11ed-a27c-1fb9b1200af4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Pontos Expirados::Regulamento Pontos Expirados',
      tabulacao_tag: 'reclamacao_conta_voebiz_pontos_expirados_regulamento_pontos_expirados_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:30:59.013Z',
    updated_at: '2022-12-28T12:30:59.013Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8b44e108-86ab-11ed-a364-7380583dd3a1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Pontos Expirados::Total de Pontos Expirados',
      tabulacao_tag: 'reclamacao_conta_voebiz_pontos_expirados_total_de_pontos_expirados_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:31:25.243Z',
    updated_at: '2022-12-28T12:31:25.243Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c40d9f6c-86ab-11ed-8981-f39ca138e8a2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Status Cadastro::Cadastro Inicial Bloqueado',
      tabulacao_tag: 'reclamacao_conta_voebiz_status_cadastro_cadastro_inicial_bloqueado_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:33:00.511Z',
    updated_at: '2022-12-28T12:33:00.511Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'feca8cc7-86ab-11ed-b44c-e72f0d2beece',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Status Cadastro::Cadastro Inicial Recusado',
      tabulacao_tag: 'reclamacao_conta_voebiz_status_cadastro_cadastro_inicial_recusado_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:34:39.057Z',
    updated_at: '2022-12-28T12:34:39.057Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '49ac0348-86ac-11ed-a27c-cf563c40d7c6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Unificação de Contas',
      tabulacao_tag: 'reclamacao_conta_voebiz_unificacao_de_contas_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T12:36:44.686Z',
    updated_at: '2022-12-28T12:36:44.686Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e7b82994-86b2-11ed-adda-ab68c0525718',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Alteração Malha Aérea GOL',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_alteracao_malha_aerea_gol_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:24:06.826Z',
    updated_at: '2022-12-28T13:24:06.826Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1e50e849-86b3-11ed-a364-e780c99fe1c1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Alteração Malha Aérea GOL',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_alteracao_malha_aerea_gol_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:25:38.424Z',
    updated_at: '2022-12-28T13:25:38.424Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7206a7f2-86b3-11ed-adda-9fffb2e1dd58',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Contestação',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_contestacao_voebiz',
      tabulacao_sla: 'sla_15_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:27:58.866Z',
    updated_at: '2022-12-28T13:27:58.866Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '87f34b6d-86b3-11ed-a27c-3950c0e00d7b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Emissão GOL Com Código Promocional',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_emissao_gol_com_codigo_promocional_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:28:35.649Z',
    updated_at: '2022-12-28T13:28:35.649Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bcf84b55-86b3-11ed-814b-1196e269312e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Disponibilidade Vôo',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_disponibilidade_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:30:04.601Z',
    updated_at: '2022-12-28T13:30:04.601Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e7744cb9-86b3-11ed-8981-5fb35cdcd598',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Erro ao Buscar Voo',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_erro_ao_buscar_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:31:15.878Z',
    updated_at: '2022-12-28T13:31:15.878Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0f12836c-86b4-11ed-814b-3d142fdf6cd1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Erro ao Concluir a Emissão',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_erro_ao_concluir_a_emissao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:32:22.346Z',
    updated_at: '2022-12-28T13:32:22.346Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '30600dc6-86b4-11ed-a364-c793cd36a860',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Erro ou Duplicidade no Pagamento',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_erro_ou_duplicidade_no_pagamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:33:18.219Z',
    updated_at: '2022-12-28T13:33:18.219Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'eadb500d-86b4-11ed-814b-91a25e718424',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Erro Token',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_erro_token_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:38:31.083Z',
    updated_at: '2022-12-28T13:38:31.083Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '478a1eac-86b5-11ed-adda-bbd903b0b8f3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Assentos Indisponíveis',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_assentos_indisponiveis_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:41:06.579Z',
    updated_at: '2022-12-28T13:41:06.579Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '00a8de3a-86b6-11ed-b44c-4f4869f94341',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:46:17.159Z',
    updated_at: '2022-12-28T13:46:17.159Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '43f458a0-86b6-11ed-8981-115e55711af8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:48:10.061Z',
    updated_at: '2022-12-28T13:48:10.061Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7d38af6b-86b6-11ed-a27c-59a15afdb79f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Alteração Involuntária::Alteração Involuntária',
      tabulacao_tag: 'reclamacao_aereas_gol_alteracao_involuntaria_alteracao_involuntaria_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:49:46.139Z',
    updated_at: '2022-12-28T13:49:46.139Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c670bbc3-86b6-11ed-adda-ffbad0c5e932',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Alteração Involuntária::Cancelamento Involuntário',
      tabulacao_tag: 'reclamacao_aereas_gol_alteracao_involuntaria_cancelamento_involuntario_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:51:48.980Z',
    updated_at: '2022-12-28T13:51:48.980Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '899f5138-86b7-11ed-814b-2df7cb0380e8',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Aéreas - GOL::Alteração Involuntária::Revalidação de Pontos Cancelamento Involuntário',
      tabulacao_tag:
        'reclamacao_aereas_gol_alteracao_involuntaria_revalidacao_de_pontos_cancelamento_involuntario_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T13:57:16.441Z',
    updated_at: '2022-12-28T13:57:16.441Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f8710a51-86ba-11ed-a364-9dae9400bbb9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Alteração Involuntária::Prejudicado No-Show',
      tabulacao_tag: 'reclamacao_aereas_gol_alteracao_involuntaria_prejudicado_noshow_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:21:50.855Z',
    updated_at: '2022-12-28T14:21:50.855Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7ad4b51b-86bb-11ed-8981-6d568f44afa1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Erro Cancelamento Site',
      tabulacao_tag: 'reclamacao_aereas_gol_cancelamento_vol_apos_24_horas_erro_cancelamento_site_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:25:29.612Z',
    updated_at: '2022-12-28T14:25:29.612Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '956258c7-86bb-11ed-8981-87262e80c2bb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancelamento_vol_apos_24_horas_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:26:14.161Z',
    updated_at: '2022-12-28T14:26:14.161Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'eb622f0a-86bb-11ed-814b-6f66d4dd4221',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_cancelamento_vol_apos_24_horas_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:28:38.444Z',
    updated_at: '2022-12-28T14:28:38.444Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5dca83f5-86bc-11ed-8981-e7bd379ab591',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:31:50.388Z',
    updated_at: '2022-12-28T14:31:50.388Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8aa2c4b0-86bc-11ed-8981-c59ac9ddaf3a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Desistiu',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:33:05.625Z',
    updated_at: '2022-12-28T14:33:05.625Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'af41ebd6-86bc-11ed-814b-dbedee94f138',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T14:34:07.066Z',
    updated_at: '2022-12-28T14:34:07.066Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e2a90d85-86d1-11ed-b44c-ff73dd5c932e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Desistiu',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:05:52.737Z',
    updated_at: '2022-12-28T17:05:52.737Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '01a7c6c2-86d2-11ed-a364-b3499c11f294',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:06:44.738Z',
    updated_at: '2022-12-28T17:06:44.738Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1b4a1f65-86d2-11ed-8981-dfe4c1d83de7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:07:27.745Z',
    updated_at: '2022-12-28T17:07:27.745Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '346b1354-86d2-11ed-adda-6d37b597b163',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:08:09.904Z',
    updated_at: '2022-12-28T17:08:09.904Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5d9fc84b-86d2-11ed-a27c-8de3bd79cf00',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Crédito de Vôo::Cred Voo Antes da Inscrição',
      tabulacao_tag: 'reclamacao_aereas_gol_credito_de_voo_cred_voo_antes_da_inscricao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:09:19.036Z',
    updated_at: '2022-12-28T17:09:19.036Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '77f348a6-86d2-11ed-b44c-974c295d167c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Crédito de Vôo::Erro Para Solicitar Crédito de Voo',
      tabulacao_tag: 'reclamacao_aereas_gol_credito_de_voo_erro_para_solicitar_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:10:03.204Z',
    updated_at: '2022-12-28T17:10:03.204Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0fab80ee-86d4-11ed-adda-f7289eb998bd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Meus Voos::Erro de Informação',
      tabulacao_tag: 'reclamacao_aereas_gol_meus_voos_erro_de_informacao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:21:27.244Z',
    updated_at: '2022-12-28T17:21:27.244Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '23703c59-86d4-11ed-b44c-15646f3ca7b4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Meus Voos::Serviço Indisponível',
      tabulacao_tag: 'reclamacao_aereas_gol_meus_voos_servico_indisponivel_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:22:00.410Z',
    updated_at: '2022-12-28T17:22:00.410Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4a457ca5-86d4-11ed-a364-b75706fd6516',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Reembolso::Erro Localizador Dividido',
      tabulacao_tag: 'reclamacao_aereas_gol_reembolso_erro_localizador_dividido_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:23:05.561Z',
    updated_at: '2022-12-28T17:23:05.561Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5e46a4e4-86d4-11ed-814b-c11c0f24989c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Reembolso::Não Concluir Reembolso de Pontos',
      tabulacao_tag: 'reclamacao_aereas_gol_reembolso_nao_concluir_reembolso_de_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:23:39.123Z',
    updated_at: '2022-12-28T17:23:39.123Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a5235c95-86d4-11ed-a364-e918a0739052',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Reembolso::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'reclamacao_aereas_gol_reembolso_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:25:38.010Z',
    updated_at: '2022-12-28T17:28:28.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '31453ae2-86d5-11ed-8981-b3415d8b395d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'reclamacao_aereas_gol_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:29:33.113Z',
    updated_at: '2022-12-28T17:29:33.113Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'aa3fb0fa-86d5-11ed-b44c-7fe878d65155',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Alteração Comercial',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_alteracao_comercial_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:32:56.081Z',
    updated_at: '2022-12-28T17:32:56.081Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bcf0d8dd-86d5-11ed-adda-798fd119eb9c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Alteração GOL',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_alteracao_gol_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:33:27.441Z',
    updated_at: '2022-12-28T17:33:27.441Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ce09ad27-86d5-11ed-a364-47e43b375a76',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Cancelamento Comercial',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_cancelamento_comercial_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:33:56.125Z',
    updated_at: '2022-12-28T17:33:56.125Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f3aa65d0-86d5-11ed-b44c-c55a7a69bf36',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Cancelamento Award',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_cancelamento_award_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:34:59.254Z',
    updated_at: '2022-12-28T17:34:59.254Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '03ae20e8-86d6-11ed-adda-0f10df61ec2f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Cancelamento GOL',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_cancelamento_gol_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:35:26.122Z',
    updated_at: '2022-12-28T17:35:26.122Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '15f58acd-86d6-11ed-adda-c795d72fea20',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Alteração GOL Diferença Tarifária',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_alteracao_gol_diferenca_tarifaria_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:35:56.789Z',
    updated_at: '2022-12-28T17:35:56.789Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd3c32c6c-86d6-11ed-b44c-b196943de543',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Flexibilização de Voos::Alteração Award',
      tabulacao_tag: 'reclamacao_aereas_gol_flexibilizacao_de_voos_alteracao_award_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:41:15.226Z',
    updated_at: '2022-12-28T17:41:15.226Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '67b6e286-86d8-11ed-814b-0b10e9cb4d28',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Não Comparecimento ao Embarque::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_nao_comparecimento_ao_embarque_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:52:32.945Z',
    updated_at: '2022-12-28T17:52:32.945Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7e51c7b4-86d8-11ed-a27c-d35c81191236',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Alteração Involuntária::Alteração Involuntária',
      tabulacao_tag: 'reclamacao_aereas_parceiras_alteracao_involuntaria_alteracao_involuntaria_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T17:53:10.870Z',
    updated_at: '2022-12-28T17:53:10.870Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0487bba9-86da-11ed-8981-3d5cdbbe5865',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Alteração Involuntária::Cancelamento Involuntário',
      tabulacao_tag: 'reclamacao_aereas_parceiras_alteracao_involuntaria_cancelamento_involuntario_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:04:05.535Z',
    updated_at: '2022-12-28T18:04:05.535Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1b81899f-86da-11ed-a364-83d70d940036',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Reclamação::Aéreas - Parceiras::Alteração Involuntária::Revalidação de Pontos Cancelamento Involuntário',
      tabulacao_tag:
        'reclamacao_aereas_parceiras_alteracao_involuntaria_revalidacao_de_pontos_cancelamento_involuntario_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:04:44.082Z',
    updated_at: '2022-12-28T18:04:44.082Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2bb94d1c-86da-11ed-adda-9df40c32bd9e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Alteração Involuntária::Prejudicado No-Show',
      tabulacao_tag: 'reclamacao_aereas_parceiras_alteracao_involuntaria_prejudicado_noshow_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:05:11.291Z',
    updated_at: '2022-12-28T18:05:11.291Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '434f5b2a-86da-11ed-a27c-490737331046',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Erro Cancelamento Site',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancelamento_vol_apos_24_horas_erro_cancelamento_site_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:05:50.862Z',
    updated_at: '2022-12-28T18:05:50.862Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '167269c8-86db-11ed-b44c-7d64b3a61aa7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancelamento_vol_apos_24_horas_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:11:45.091Z',
    updated_at: '2022-12-28T18:11:45.091Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '52e07795-86dd-11ed-b44c-b1f1355d9796',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancelamento_vol_apos_24_horas_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:27:45.469Z',
    updated_at: '2022-12-28T18:27:45.469Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '45c1be47-86de-11ed-8981-6f5923942caf',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:34:32.954Z',
    updated_at: '2022-12-28T18:34:32.954Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '61e17385-86de-11ed-adda-2f7bb792e82c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Desistiu',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:35:20.138Z',
    updated_at: '2022-12-28T18:35:20.138Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '758b536d-86de-11ed-a27c-75919d5d2900',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:35:53.128Z',
    updated_at: '2022-12-28T18:35:53.128Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1ebcec2b-86df-11ed-b44c-29d1021c7386',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:40:36.988Z',
    updated_at: '2022-12-28T18:40:36.988Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7aa50f1b-86df-11ed-b44c-07b0e2f5dd81',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:43:11.182Z',
    updated_at: '2022-12-28T18:43:11.182Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '900f3cc6-86df-11ed-adda-f579fc5aefb6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Desistiu',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:43:47.110Z',
    updated_at: '2022-12-28T18:43:47.110Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'abd78303-86df-11ed-8981-03169fe8fb10',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Solicitação de Cancelamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_solicitacao_de_cancelamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:44:33.721Z',
    updated_at: '2022-12-28T18:44:33.721Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bd472a58-86df-11ed-a27c-6d9fe82f4a9b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:45:02.974Z',
    updated_at: '2022-12-28T18:45:02.974Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ce5be0d3-86df-11ed-814b-0d27347cb93e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:45:31.631Z',
    updated_at: '2022-12-28T18:45:31.631Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e0895952-86df-11ed-a364-f956b1201ebf',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Crédito de Vôo::Cred Voo Antes da Inscrição',
      tabulacao_tag: 'reclamacao_aereas_parceiras_credito_de_voo_cred_voo_antes_da_inscricao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:46:02.128Z',
    updated_at: '2022-12-28T18:46:02.128Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0cb1847b-86e0-11ed-814b-1ddf8a7099b5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Crédito de Vôo::Erro Para Solicitar Crédito de Voo',
      tabulacao_tag: 'reclamacao_aereas_parceiras_credito_de_voo_erro_para_solicitar_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:47:16.211Z',
    updated_at: '2022-12-28T18:47:16.211Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '304025d9-86e0-11ed-8981-5f4d598e11c8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Crédito de Vôo::Regra de Acúmulo',
      tabulacao_tag: 'reclamacao_aereas_parceiras_credito_de_voo_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:48:15.866Z',
    updated_at: '2022-12-28T18:48:15.866Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '40f75301-86e0-11ed-814b-f7b834393398',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Meus Voos::Erro de Informação',
      tabulacao_tag: 'reclamacao_aereas_parceiras_meus_voos_erro_de_informacao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:48:43.910Z',
    updated_at: '2022-12-28T18:48:43.910Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '54c4e6e6-86e0-11ed-a364-77f5879c0f5d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Meus Voos::Serviço Indisponível',
      tabulacao_tag: 'reclamacao_aereas_parceiras_meus_voos_servico_indisponivel_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:49:17.134Z',
    updated_at: '2022-12-28T18:49:17.134Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b7b96481-86e0-11ed-adda-7b5e04dfe5ba',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Reembolso::Erro Localizador Dividido',
      tabulacao_tag: 'reclamacao_aereas_parceiras_reembolso_erro_localizador_dividido_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:52:03.153Z',
    updated_at: '2022-12-28T18:52:03.153Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ca669520-86e0-11ed-814b-c1d4cf82f28d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Reembolso::Não Concluir Reembolso de Pontos',
      tabulacao_tag: 'reclamacao_aereas_parceiras_reembolso_nao_concluir_reembolso_de_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:52:34.487Z',
    updated_at: '2022-12-28T18:52:34.487Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd8738957-86e0-11ed-b44c-7db5adaee903',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Reembolso::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'reclamacao_aereas_parceiras_reembolso_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:52:58.060Z',
    updated_at: '2022-12-28T18:52:58.060Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'aed23aef-86e1-11ed-a27c-2736c37529f3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'reclamacao_aereas_parceiras_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:58:57.713Z',
    updated_at: '2022-12-28T18:58:57.713Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c7d063ca-86e1-11ed-a27c-cff90fc166e2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Alteração Comercial',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_alteracao_comercial_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T18:59:39.644Z',
    updated_at: '2022-12-28T18:59:39.644Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd91bbadf-86e1-11ed-adda-4f7a9c78ff92',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Alteração Parceira',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_alteracao_parceira_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:00:08.659Z',
    updated_at: '2022-12-28T19:00:08.659Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e7e6a82b-86e1-11ed-adda-a386e85ffee7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Cancelamento Comercial',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_cancelamento_comercial_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:00:33.477Z',
    updated_at: '2022-12-28T19:00:33.477Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fc5a1995-86e1-11ed-8981-d14d3a72d9ae',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Cancelamento Award',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_cancelamento_award_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:01:07.788Z',
    updated_at: '2022-12-28T19:01:07.788Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0dbcc80c-86e2-11ed-adda-c95200ccaf3c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Cancelamento Parceira',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_cancelamento_parceira_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:01:36.956Z',
    updated_at: '2022-12-28T19:06:22.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd9fb3373-86e3-11ed-a27c-cf84bd4621ca',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Alteração Parceira Diferença Tarifária',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_alteracao_parceira_diferenca_tarifaria_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:14:29.117Z',
    updated_at: '2022-12-28T19:14:29.117Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f360d139-86e3-11ed-b44c-ffc53697d7dd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Flexibilização de Voos::Alteração Award',
      tabulacao_tag: 'reclamacao_aereas_parceiras_flexibilizacao_de_voos_alteracao_award_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:15:11.726Z',
    updated_at: '2023-01-30T20:50:45.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '178c2876-86e4-11ed-a364-e513a1c06f9c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Não Comparecimento ao Embarque::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_nao_comparecimento_ao_embarque_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_reclamacao',
    },
    created_at: '2022-12-28T19:16:12.408Z',
    updated_at: '2022-12-28T19:16:12.408Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bcea8fa9-8b70-11ed-99f7-dd7b2248ddb7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aeroporto::Serviços Especiais Vôo GOL',
      tabulacao_tag: 'solicitacao_aeroporto_servicos_especiais_voo_gol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:13:04.044Z',
    updated_at: '2023-01-03T14:13:04.044Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'df13acd3-8b70-11ed-99f7-d5690fd2acae',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aeroporto::Taxa::Isenção de Taxa Laudo Médico',
      tabulacao_tag: 'solicitacao_aeroporto_taxa_isencao_de_taxa_laudo_medico_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:14:01.356Z',
    updated_at: '2023-01-03T14:14:01.356Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e8e9d616-8b70-11ed-adda-2778961404b9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aeroporto::Taxa',
      tabulacao_tag: 'solicitacao_aeroporto_taxa_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:14:17.859Z',
    updated_at: '2023-01-03T14:14:17.859Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fff1fc38-8b70-11ed-adda-bd4d8e60de9f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cadastro::Análise de Novo Cadastro',
      tabulacao_tag: 'solicitacao_conta_voebiz_cadastro_analise_de_novo_cadastro_voebiz',
      tabulacao_sla: 'sla_15_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:14:56.500Z',
    updated_at: '2023-01-03T14:14:56.500Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0f91294b-8b71-11ed-8981-c181091c4abe',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Atualização Cadastral::Atualização Cadastral - Dados Empresa',
      tabulacao_tag: 'solicitacao_conta_voebiz_atualizacao_cadastral_atualizacao_cadastral_dados_empresa_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:15:22.709Z',
    updated_at: '2023-01-03T14:17:23.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '40cf34e7-8b71-11ed-b50f-179ad1341c1d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Atualização Cadastral::Atualização Cadastral - Dados Administrador',
      tabulacao_tag: 'solicitacao_conta_voebiz_atualizacao_cadastral_atualizacao_cadastral_dados_administrador_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:16:45.324Z',
    updated_at: '2023-01-03T14:16:45.324Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '694d1cf2-8b71-11ed-b50f-0bf35e9229ea',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Atualização Cadastral::Atualização - Lista de Passageiros Favoritos',
      tabulacao_tag: 'solicitacao_conta_voebiz_atualizacao_cadastral_atualizacao_lista_de_passageiros_favoritos_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:17:53.258Z',
    updated_at: '2023-01-03T14:17:53.258Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8e2073f5-8b71-11ed-adda-4b3e8d155af2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Atualização Cadastral::Unificação de Contas',
      tabulacao_tag: 'solicitacao_conta_voebiz_atualizacao_cadastral_unificacao_de_contas_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:18:55.041Z',
    updated_at: '2023-01-03T14:18:55.041Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a6bb202e-8b71-11ed-99b0-45e2c0085fca',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cancelamento::Insatisfeito',
      tabulacao_tag: 'solicitacao_conta_voebiz_cancelamento_insatisfeito_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:19:36.320Z',
    updated_at: '2023-01-03T14:19:36.320Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b6ef3aea-8b71-11ed-b50f-c98b2304b94e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cancelamento::Não Tem Mais Interesse em Participar do Programa',
      tabulacao_tag: 'solicitacao_conta_voebiz_cancelamento_nao_tem_mais_interesse_em_participar_do_programa_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:20:03.505Z',
    updated_at: '2023-01-03T14:20:03.505Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c7dfedad-8b71-11ed-adda-3d5825daf75d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cancelamento::Não Utiliza',
      tabulacao_tag: 'solicitacao_conta_voebiz_cancelamento_nao_utiliza_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:20:31.926Z',
    updated_at: '2023-01-03T14:20:31.926Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd7150e68-8b71-11ed-adda-4d4344c0b071',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cancelamento::Migração Para Acordo Corporativo',
      tabulacao_tag: 'solicitacao_conta_voebiz_cancelamento_migracao_para_acordo_corporativo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:20:57.440Z',
    updated_at: '2023-01-03T14:20:57.440Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e4390215-8b71-11ed-b50f-19f0dd8a6f31',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Cancelamento::Outros',
      tabulacao_tag: 'solicitacao_conta_voebiz_cancelamento_outros_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:21:19.486Z',
    updated_at: '2023-01-03T14:21:19.486Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f1d09f9f-8b71-11ed-8981-9b047c655d6a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Categoria - Conta VoeBiz::Regulamento',
      tabulacao_tag: 'solicitacao_conta_voebiz_categoria_conta_voebiz_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:21:42.290Z',
    updated_at: '2023-01-03T14:21:42.290Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ffe646df-8b71-11ed-99f7-7dd7c52c83fd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Categoria - Conta VoeBiz::Saldo de Pontos Qualificáveis',
      tabulacao_tag: 'solicitacao_conta_voebiz_categoria_conta_voebiz_saldo_de_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:22:05.920Z',
    updated_at: '2023-01-03T14:22:05.920Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0d19f23d-8b72-11ed-99f7-6d393c26fae7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Categoria - Conta VoeBiz::Análise de Upgrade',
      tabulacao_tag: 'solicitacao_conta_voebiz_categoria_conta_voebiz_analise_de_upgrade_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:22:28.069Z',
    updated_at: '2023-01-03T14:22:28.069Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2a56fd45-8b72-11ed-99f7-a3ee5e2af5b6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Categoria - Conta VoeBiz::Benefícios da Categoria',
      tabulacao_tag: 'solicitacao_conta_voebiz_categoria_conta_voebiz_beneficios_da_categoria_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:23:17.123Z',
    updated_at: '2023-01-03T14:23:17.123Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8f6be9ac-8b72-11ed-a27c-9526192ce34f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Senha::Desbloqueio de Senha',
      tabulacao_tag: 'solicitacao_conta_voebiz_senha_desbloqueio_de_senha_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:26:06.710Z',
    updated_at: '2023-01-03T14:26:06.710Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9fcdca56-8b72-11ed-99f7-23a43e78d2c6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Senha::Determinação Judicial',
      tabulacao_tag: 'solicitacao_conta_voebiz_senha_determinacao_judicial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_suporte_comercial_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:26:34.195Z',
    updated_at: '2023-01-03T14:26:34.195Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ace5b025-8b72-11ed-8981-0746f2f65c4a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Senha::Pedido de Senha',
      tabulacao_tag: 'solicitacao_conta_voebiz_senha_pedido_de_senha_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:26:56.162Z',
    updated_at: '2023-01-03T14:26:56.162Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'baae96d0-8b72-11ed-99f7-e5a9b568b8c1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Resgate Não Processado',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_resgate_nao_processado_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:27:19.289Z',
    updated_at: '2023-01-03T14:27:19.289Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0b3c3bb8-8b73-11ed-8981-f3c9e64875ff',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Extrato Indisponível no Site',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_extrato_indisponivel_no_site_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:29:34.435Z',
    updated_at: '2023-01-03T14:29:34.435Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '25f97abb-8b73-11ed-8981-cb13ef8c85c6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Cobrança Duplicada',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_cobranca_duplicada_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:30:19.296Z',
    updated_at: '2023-01-03T14:30:19.296Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '568dd9ec-8b73-11ed-8981-31df3e7efc1d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Não Concorda Com Saldo',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_nao_concorda_com_saldo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:31:40.799Z',
    updated_at: '2023-01-03T14:31:40.799Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '62ad2f01-8b73-11ed-adda-3907113a6a73',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Saldo de Pontos Resgatáveis',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_saldo_de_pontos_resgataveis_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:32:01.137Z',
    updated_at: '2023-01-03T14:32:01.137Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6e68e036-8b73-11ed-99b0-2ff5e19f2c7d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Saldo de Pontos Qualificáveis',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_saldo_de_pontos_qualificaveis_voebiz',
      tabulacao_sla: 'sla_10_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:32:20.822Z',
    updated_at: '2023-01-03T14:32:20.822Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '86986f1e-8b73-11ed-a27c-f95351ab83a7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Pontos Expirados',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_pontos_expirados_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:33:01.399Z',
    updated_at: '2023-01-03T14:33:01.399Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd45c6c0b-8b73-11ed-99b0-5dc532df1222',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Solicitação de Dados Legado',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_solicitacao_de_dados_legado_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:35:11.868Z',
    updated_at: '2023-01-03T14:35:11.868Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f028f7e4-8b73-11ed-a27c-1d17d0823262',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Conta VoeBiz::Acúmulo Não Processado',
      tabulacao_tag: 'solicitacao_conta_voebiz_conta_voebiz_acumulo_nao_processado_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:35:58.507Z',
    updated_at: '2023-01-03T14:35:58.507Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fbc70f35-8b73-11ed-b50f-03158198d05e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Número VoeBiz::Informações Novo Número VoeBiz',
      tabulacao_tag: 'solicitacao_conta_voebiz_numero_voebiz_informacoes_novo_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:36:17.998Z',
    updated_at: '2023-01-03T14:36:17.998Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '161e60ae-8b74-11ed-99b0-2bc5f1748b16',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Pontos Expirados::Regulamento',
      tabulacao_tag: 'solicitacao_conta_voebiz_pontos_expirados_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:37:02.191Z',
    updated_at: '2023-01-03T14:37:02.191Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2163f6ec-8b74-11ed-adda-8d24c240e272',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Pontos Expirados::Total de Pontos Expirados',
      tabulacao_tag: 'solicitacao_conta_voebiz_pontos_expirados_total_de_pontos_expirados_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:37:21.102Z',
    updated_at: '2023-01-03T14:37:21.102Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3c98fea9-8b74-11ed-99b0-f1bc32510ac4',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Status da Conta::Análise Status Falecido',
      tabulacao_tag: 'solicitacao_conta_voebiz_status_da_conta_analise_status_falecido_voebiz',
      tabulacao_sla: 'sla_10_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:38:06.748Z',
    updated_at: '2023-01-03T14:38:06.748Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '49982bd7-8b74-11ed-adda-21488a09c28a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Status da Conta::Análise Status Suspenso',
      tabulacao_tag: 'solicitacao_conta_voebiz_status_da_conta_analise_status_suspenso_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:38:28.553Z',
    updated_at: '2023-01-03T14:38:28.553Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5cd73c7c-8b74-11ed-b50f-9934d28fa82e',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Solicitação::Conta VoeBiz::Status da Conta::Reativação de Conta - Migração de Acordo Corporativo',
      tabulacao_tag:
        'solicitacao_conta_voebiz_status_da_conta_reativacao_de_conta_migracao_de_acordo_corporativo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:39:00.843Z',
    updated_at: '2023-01-03T14:39:00.843Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '69d61be1-8b74-11ed-99f7-a380e8ec3671',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Status da Conta::Reativação de Conta',
      tabulacao_tag: 'solicitacao_conta_voebiz_status_da_conta_reativacao_de_conta_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:39:22.646Z',
    updated_at: '2023-01-03T14:39:22.646Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '83b0c262-8b74-11ed-b50f-172411a78d31',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Upgrade::Análise de Upgrade',
      tabulacao_tag: 'solicitacao_conta_voebiz_upgrade_analise_de_upgrade_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:40:06.022Z',
    updated_at: '2023-01-03T14:40:06.022Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '91a0e039-8b74-11ed-a27c-8fb6981b7d8a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Upgrade::Upgrade Manual',
      tabulacao_tag: 'solicitacao_conta_voebiz_upgrade_upgrade_manual_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:40:29.406Z',
    updated_at: '2023-01-03T14:40:29.406Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9efbea3d-8b74-11ed-8981-bf3a56d6c240',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::E-mail Marketing Fraude',
      tabulacao_tag: 'solicitacao_conta_voebiz_email_marketing_fraude_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:40:51.813Z',
    updated_at: '2023-01-03T14:40:51.813Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '14b787c3-8b75-11ed-99b0-bd83421609b2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Juridico::Acordo Jurídico Gol',
      tabulacao_tag: 'solicitacao_conta_voebiz_juridico_acordo_juridico_gol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:44:09.336Z',
    updated_at: '2023-01-03T14:44:09.336Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2976f6b9-8b75-11ed-8981-9767a18fbdbf',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Juridico::Acordo Jurídico VoeBiz',
      tabulacao_tag: 'solicitacao_conta_voebiz_juridico_acordo_juridico_voebiz_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:44:44.145Z',
    updated_at: '2023-01-03T14:44:44.145Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e4db6a47-8b76-11ed-99b0-b9a22f27c55b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Juridico::Determinação Judicial',
      tabulacao_tag: 'solicitacao_conta_voebiz_juridico_determinacao_judicial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:57:08.034Z',
    updated_at: '2023-01-03T14:57:08.034Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f85b2da4-8b76-11ed-b50f-79bd068d109f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Emissão Pela Central',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_emissao_pela_central_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:57:40.748Z',
    updated_at: '2023-01-03T14:57:40.748Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '058f4dc3-8b77-11ed-adda-37844ce702a2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Contestação',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_contestacao_voebiz',
      tabulacao_sla: 'sla_15_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:58:02.900Z',
    updated_at: '2023-01-03T14:58:02.900Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1b2aeba4-8b77-11ed-99f7-1f0a9a9e32de',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Duplicidade de Emissão',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_duplicidade_de_emissao_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:58:39.152Z',
    updated_at: '2023-01-03T14:58:39.152Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2a505504-8b77-11ed-a27c-3978176dd6ec',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Cancelamento Central',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_cancelamento_central_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:59:04.563Z',
    updated_at: '2023-02-01T13:39:02.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3992e305-8b77-11ed-adda-e55e810aa11b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:59:30.165Z',
    updated_at: '2023-01-03T14:59:30.165Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '43be7e77-8b77-11ed-8981-bb5904a08289',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Alteração Involuntária::Alteração Involuntária',
      tabulacao_tag: 'solicitacao_aereas_gol_alteracao_involuntaria_alteracao_involuntaria_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T14:59:47.228Z',
    updated_at: '2023-01-03T14:59:47.228Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4f780c67-8b77-11ed-b50f-791899072af8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Alteração Involuntária::Cancelamento Involuntário',
      tabulacao_tag: 'solicitacao_aereas_gol_alteracao_involuntaria_cancelamento_involuntario_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:00:06.899Z',
    updated_at: '2023-01-03T15:00:06.899Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '62644189-8b77-11ed-a27c-7bd23005a539',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Alteração Involuntária::Revalidação de Pontos Cancel Invol.',
      tabulacao_tag: 'solicitacao_aereas_gol_alteracao_involuntaria_revalidacao_de_pontos_cancel_invol_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:00:38.646Z',
    updated_at: '2023-01-03T15:00:38.646Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9fd244fb-8b77-11ed-8981-6d23fa479da6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Antecipação Voluntária::Duplicidade de Reservas',
      tabulacao_tag: 'solicitacao_aereas_gol_antecipacao_voluntaria_duplicidade_de_reservas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:02:21.708Z',
    updated_at: '2023-01-03T15:02:21.708Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b3a41f87-8b77-11ed-a27c-cda053c3bcf5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Antecipação Voluntária::Antecipação Voo 6 Horas',
      tabulacao_tag: 'solicitacao_aereas_gol_antecipacao_voluntaria_antecipacao_voo_6_horas_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:02:54.960Z',
    updated_at: '2023-01-03T15:02:54.960Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c2f99966-8b77-11ed-adda-f545a5313b82',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Antecipação Voluntária::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_gol_antecipacao_voluntaria_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:03:20.686Z',
    updated_at: '2023-01-03T15:03:20.686Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd1184106-8b77-11ed-adda-e1f270285837',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Cancel Excepcional Gol Parcial',
      tabulacao_tag: 'solicitacao_aereas_gol_cancelamento_vol_apos_24_horas_cancel_excepcional_gol_parcial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:03:44.375Z',
    updated_at: '2023-01-03T15:03:44.375Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'dd9ebca2-8b77-11ed-a27c-217f418aab85',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Cancelamento Central',
      tabulacao_tag: 'solicitacao_aereas_gol_cancelamento_vol_apos_24_horas_cancelamento_central_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:04:05.389Z',
    updated_at: '2023-01-03T15:04:05.389Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ea973374-8b77-11ed-99b0-9bffccb27c85',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Cancel Excepcional Gol Total',
      tabulacao_tag: 'solicitacao_aereas_gol_cancelamento_vol_apos_24_horas_cancel_excepcional_gol_total_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:04:27.150Z',
    updated_at: '2023-01-03T15:04:27.150Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f74e5bf2-8b77-11ed-99f7-0ba21aa1356f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Cancelamento',
      tabulacao_tag: 'solicitacao_aereas_gol_cancelamento_vol_apos_24_horas_cancelamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:04:48.483Z',
    updated_at: '2023-01-03T15:04:48.483Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '29e96010-8b78-11ed-b50f-054ea7fc9253',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_gol_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:06:13.385Z',
    updated_at: '2023-01-03T15:06:13.385Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '37f93a4c-8b78-11ed-8981-81754a832693',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Desistiu',
      tabulacao_tag: 'solicitacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:06:36.977Z',
    updated_at: '2023-01-03T15:06:36.977Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '425115b2-8b78-11ed-99b0-b5b88f04903a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Nome Incorreto',
      tabulacao_tag: 'solicitacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:06:54.330Z',
    updated_at: '2023-01-03T15:06:54.330Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '58854a36-8b78-11ed-99f7-fb36f7d6872d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Desistiu',
      tabulacao_tag: 'solicitacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:07:31.582Z',
    updated_at: '2023-01-03T15:07:31.582Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6447166d-8b78-11ed-b50f-b191b3fb3c34',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Cancel Vol. 24h Voo Dentro 7 Dias::Nome Incorreto',
      tabulacao_tag: 'solicitacao_aereas_gol_cancel_vol_24h_voo_dentro_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:07:51.307Z',
    updated_at: '2023-01-03T15:07:51.307Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '77574e2c-8b78-11ed-99f7-a972ea815710',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Reembolso::Reembolso Taxa de Embarque R$',
      tabulacao_tag: 'solicitacao_aereas_gol_reembolso_reembolso_taxa_de_embarque_r_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:08:23.290Z',
    updated_at: '2023-01-03T15:08:23.290Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8591e23e-8b78-11ed-99f7-ef539df73684',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Reembolso::Reembolso Taxa de Embarque Pontos',
      tabulacao_tag: 'solicitacao_aereas_gol_reembolso_reembolso_taxa_de_embarque_pontos_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:08:47.162Z',
    updated_at: '2023-01-03T15:08:47.162Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '92b97ff9-8b78-11ed-b50f-85158e2a5eb7',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'solicitacao_aereas_gol_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:09:09.232Z',
    updated_at: '2023-01-03T15:09:09.232Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a73dba4f-8b78-11ed-a27c-19fdf998c73f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Voo Acumulado em Outra Conta',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_voo_acumulado_em_outra_conta_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:09:43.653Z',
    updated_at: '2023-01-03T15:09:43.653Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b6482147-8b78-11ed-8981-f7d6581bec9e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Account Code Prime - Inclusão de Agência',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_account_code_prime_inclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:10:08.887Z',
    updated_at: '2023-01-03T15:10:08.887Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'cb0fccdf-8b78-11ed-a27c-2f8500e64665',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Account Code Prime - Exclusão de Agência',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_account_code_prime_exclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:10:43.750Z',
    updated_at: '2023-01-03T15:10:43.750Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e3371e6d-8b78-11ed-adda-25b76b890d9f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Incluir Número VoeBiz',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_incluir_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:11:24.273Z',
    updated_at: '2023-01-03T15:11:24.273Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f127d8c7-8b78-11ed-b50f-a73a1dd68aba',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Dados Divergêntes',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_dados_divergentes_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:11:47.661Z',
    updated_at: '2023-01-03T15:11:47.661Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fcc468dd-8b78-11ed-99b0-d5e66ee0446f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Voo Codeshare',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_voo_codeshare_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:12:07.142Z',
    updated_at: '2023-01-03T15:12:07.142Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '07d5345a-8b79-11ed-8981-1b0ddabfab7e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Cred Voo Antes da Inscrição',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_cred_voo_antes_da_inscricao_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:12:25.707Z',
    updated_at: '2023-01-03T15:12:25.707Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '23f4e960-8b79-11ed-adda-89e577604a1b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Extensão de Pontos - Ação Comercial',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_extensao_de_pontos_acao_comercial_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:13:12.891Z',
    updated_at: '2023-01-03T15:13:12.891Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2f544946-8b79-11ed-a27c-f1927bdea125',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito de Vôo::Crédito de Voo',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_de_voo_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:13:31.971Z',
    updated_at: '2023-01-03T15:13:31.971Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '49c082b4-8b79-11ed-8981-478befec73dc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Crédito Underpaid::Regra de Acúmulo',
      tabulacao_tag: 'solicitacao_aereas_gol_credito_underpaid_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:14:16.301Z',
    updated_at: '2023-01-03T15:14:16.301Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6436cc9a-8b79-11ed-8981-5180d3966aa9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Tarifa Comercial',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_tarifa_comercial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:15:00.697Z',
    updated_at: '2023-01-03T15:15:00.697Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '74db8354-8b79-11ed-b50f-6f41e6601de3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Aceito a Remarcação',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_aceito_a_remarcacao_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:15:28.620Z',
    updated_at: '2023-01-03T15:15:28.620Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8b295a28-8b79-11ed-b50f-bf24c00c1268',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Alteração Diferença Tarifária',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_alteracao_diferenca_tarifaria_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:16:06.040Z',
    updated_at: '2023-01-03T15:16:06.040Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '971717a6-8b79-11ed-99f7-01718b626681',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Falta de Disponibilidade',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_falta_de_disponibilidade_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:16:26.053Z',
    updated_at: '2023-01-03T15:16:26.053Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a65b5390-8b79-11ed-8981-537693e1c69a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Grupo de Risco',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_grupo_de_risco_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:16:51.666Z',
    updated_at: '2023-01-03T15:16:51.666Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b7158d85-8b79-11ed-adda-15e71be99bb0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Não Tem Nova Data Definida',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_nao_tem_nova_data_definida_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:17:19.730Z',
    updated_at: '2023-01-03T15:17:19.730Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c0e8d035-8b79-11ed-a27c-4b30f1aa451f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Não Vai Viajar',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_nao_vai_viajar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:17:36.214Z',
    updated_at: '2023-01-03T15:17:36.214Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ca8af07c-8b79-11ed-b50f-19389cd2dc7c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Queria Reitinerar',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_queria_reitinerar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:17:52.376Z',
    updated_at: '2023-01-03T15:17:52.376Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd3f92efb-8b79-11ed-adda-bd518c6bd2c8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Queria Trocar de Parceiro Aéreo',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_queria_trocar_de_parceiro_aereo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:18:08.198Z',
    updated_at: '2023-01-03T15:18:08.198Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'df5f45b6-8b79-11ed-a27c-0babd86e562c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Flexibilização de Voos::Queria Trocar os Passageiros',
      tabulacao_tag: 'solicitacao_aereas_gol_flexibilizacao_de_voos_queria_trocar_os_passageiros_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:18:27.322Z',
    updated_at: '2023-01-03T15:18:27.322Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ec66b1ba-8b79-11ed-8981-6b9df2fb82e0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Bilhete::Envio de Bilhete',
      tabulacao_tag: 'solicitacao_aereas_gol_bilhete_envio_de_bilhete_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:18:49.181Z',
    updated_at: '2023-01-03T15:18:49.181Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f8ef4fde-8b79-11ed-99b0-61ce788095c3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Bilhete::Envio de Declaração - Embarque',
      tabulacao_tag: 'solicitacao_aereas_gol_bilhete_envio_de_declaracao_embarque_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:19:10.209Z',
    updated_at: '2023-01-03T15:19:10.209Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '03c24ee6-8b7a-11ed-99b0-3112e34c44d2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Bilhete::Envio de Declaração - Valores',
      tabulacao_tag: 'solicitacao_aereas_gol_bilhete_envio_de_declaracao_valores_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:19:28.369Z',
    updated_at: '2023-01-03T15:19:28.369Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '984f73bf-8b7d-11ed-99b0-b3a7b0e1665b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Emissão Pela Central',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_emissao_pela_central_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:45:06.087Z',
    updated_at: '2023-01-03T15:45:06.087Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a5686ad2-8b7d-11ed-a27c-e95d588a6831',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Emissão Com Código Promocional',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_emissao_com_codigo_promocional_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:45:28.061Z',
    updated_at: '2023-01-03T15:45:28.061Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b2083b02-8b7d-11ed-99b0-819f6eabbc34',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Disponibilidade Vôo',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_disponibilidade_voo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:45:49.241Z',
    updated_at: '2023-01-03T15:45:49.241Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c5c506eb-8b7d-11ed-8981-8916a9446852',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Aeroporto Indisponivel na Lista',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_aeroporto_indisponivel_na_lista_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:46:22.355Z',
    updated_at: '2023-01-03T15:46:22.355Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd1c5afcb-8b7d-11ed-b50f-db9180197f55',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Duplicidade de Emissão',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_duplicidade_de_emissao_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:46:42.492Z',
    updated_at: '2023-01-03T15:46:42.492Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '019dc46c-8b7e-11ed-99b0-555b653959c3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Correção de Nome',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_correcao_de_nome_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:48:02.761Z',
    updated_at: '2023-01-03T15:48:02.761Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '0e1e4c13-8b7e-11ed-a27c-15c085470d09',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Contestação',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_contestacao_voebiz',
      tabulacao_sla: 'sla_15_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:48:23.736Z',
    updated_at: '2023-01-03T15:48:23.736Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '20678a67-8b7e-11ed-b50f-3fce322e8148',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Cancelamento Central',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_cancelamento_central_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:48:54.415Z',
    updated_at: '2023-02-01T16:25:10.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2f848ee1-8b7e-11ed-adda-c5cb3f46e363',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Emissão::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_parceiras_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:49:19.771Z',
    updated_at: '2023-01-03T15:49:19.771Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '405bc6aa-8b7e-11ed-99b0-958d9f42cd1c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cliente Aceita - Award',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cliente_aceita_award_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:49:48.025Z',
    updated_at: '2023-01-03T15:49:48.025Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5238130c-8b7e-11ed-b50f-43ed6bc4cc5d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cliente Aceita - Comercial',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cliente_aceita_comercial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:50:17.990Z',
    updated_at: '2023-01-03T15:50:17.990Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5ec8c770-8b7e-11ed-8981-67996c8bac67',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cliente NÃO Aceita - Award',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cliente_nao_aceita_award_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:50:39.071Z',
    updated_at: '2023-01-03T15:50:39.071Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '76386215-8b7e-11ed-99f7-53499dc3b6c1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cliente NÃO Aceita - Comercial',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cliente_nao_aceita_comercial_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:51:18.390Z',
    updated_at: '2023-01-03T15:51:18.390Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '82b62b2d-8b7e-11ed-b50f-e74c7bd048c5',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cancelamento Involuntário - Award',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cancelamento_involuntario_award_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:51:39.347Z',
    updated_at: '2023-01-03T15:51:39.347Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8f803f1d-8b7e-11ed-8981-0d52624c6718',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Cancelamento Involuntário - Comercial',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_cancelamento_involuntario_comercial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:52:00.804Z',
    updated_at: '2023-01-03T15:52:00.804Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9bd6f788-8b7e-11ed-a27c-aba647f9b2d9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Prejudicado No-Show',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_prejudicado_noshow_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:52:21.505Z',
    updated_at: '2023-01-03T15:52:21.505Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a9da9cc5-8b7e-11ed-b50f-2915223bb8b6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Alteração Involuntária::Revalidação de Pontos Cancel Invol.',
      tabulacao_tag: 'solicitacao_aereas_parceiras_alteracao_involuntaria_revalidacao_de_pontos_cancel_invol_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:52:45.017Z',
    updated_at: '2023-01-03T15:52:45.017Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bcbbd5df-8b7e-11ed-a27c-fb31730412c8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Cancelamento Central',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancelamento_vol_apos_24_horas_cancelamento_central_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:53:16.692Z',
    updated_at: '2023-01-03T15:53:16.692Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c8928984-8b7e-11ed-adda-3fba61d24b02',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Nome Incorreto',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancelamento_vol_apos_24_horas_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:53:36.554Z',
    updated_at: '2023-01-03T15:53:36.554Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e6cd5641-8b7e-11ed-a27c-53545dea1951',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancelamento Vol. Após 24 Horas::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancelamento_vol_apos_24_horas_regulamento_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:54:27.271Z',
    updated_at: '2023-01-03T15:54:27.271Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fc17c604-8b7e-11ed-99b0-0948a89c3583',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Desistiu',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:55:02.991Z',
    updated_at: '2023-01-03T15:55:02.991Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '07fc83a5-8b7f-11ed-99f7-79b02ef5ef7e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Cancelamento Por Passageiro',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_cancelamento_por_passageiro_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:55:22.945Z',
    updated_at: '2023-01-03T15:55:22.945Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1331ee59-8b7f-11ed-b50f-3583e47c616d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Nome Incorreto',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:55:41.750Z',
    updated_at: '2023-01-03T15:55:41.750Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '26f7ba90-8b7f-11ed-adda-e160b950d51c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Após 7 Dias::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_apos_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:56:14.923Z',
    updated_at: '2023-01-03T15:56:14.923Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '34372519-8b7f-11ed-b50f-ef60e049fc4b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Desistiu',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_desistiu_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:56:37.149Z',
    updated_at: '2023-01-03T15:56:37.149Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '48c79510-8b7f-11ed-99b0-fd6ffeb1f80b',
    external_id: null,
    attributes: {
      tabulacao_value:
        'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Cancelamento Por Passageiro',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_cancelamento_por_passageiro_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:57:11.650Z',
    updated_at: '2023-01-03T15:57:11.650Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '527c03da-8b7f-11ed-adda-43141f03169c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Nome Incorreto',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:57:27.932Z',
    updated_at: '2023-01-03T15:57:27.932Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '5eee8242-8b7f-11ed-99f7-df7684c51305',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Cancel Vol. 24h Voo Dentro 7 Dias::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_parceiras_cancel_vol_24h_voo_dentro_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:57:48.815Z',
    updated_at: '2023-01-03T15:57:48.815Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7231ff45-8b7f-11ed-99f7-ab83f0b8e46b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Voo Acumulado em Outra Conta',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_voo_acumulado_em_outra_conta_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:58:21.134Z',
    updated_at: '2023-01-03T15:58:21.134Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7fbd194b-8b7f-11ed-adda-535959496452',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Account Code Prime - Inclusão de Agência',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_account_code_prime_inclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:58:43.856Z',
    updated_at: '2023-01-03T15:58:43.856Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '926519c5-8b7f-11ed-99f7-af2f9b9c5bcb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Account Code Prime - Exclusão de Agência',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_account_code_prime_exclusao_de_agencia_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:59:15.156Z',
    updated_at: '2023-01-03T15:59:15.156Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9f504a1e-8b7f-11ed-a27c-5def10078c12',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Incluir Número VoeBiz',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_incluir_numero_voebiz_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T15:59:36.830Z',
    updated_at: '2023-01-03T15:59:36.830Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c9c287d9-8b7f-11ed-b50f-f58efc673fc1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Dados Divergêntes',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_dados_divergentes_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:00:48.043Z',
    updated_at: '2023-01-03T16:00:48.043Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'da2f3e13-8b7f-11ed-8981-4b281a80d343',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Voo Codeshare',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_voo_codeshare_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:01:15.599Z',
    updated_at: '2023-01-03T16:01:15.599Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e8860ca6-8b7f-11ed-99f7-9754c52ecbac',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Cred Voo Antes da Inscrição',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_cred_voo_antes_da_inscricao_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:01:39.656Z',
    updated_at: '2023-01-03T16:01:39.656Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f7e12ca8-8b7f-11ed-99b0-0766d643cb0b',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Extensão de Pontos - Ação Comercial',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_extensao_de_pontos_acao_comercial_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:02:05.419Z',
    updated_at: '2023-01-03T16:02:05.419Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '044552f7-8b80-11ed-a27c-4fa7f23e6c09',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Crédito de Voo',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_30_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:02:26.208Z',
    updated_at: '2023-01-03T16:02:26.208Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '552f47bf-8b80-11ed-99b0-6bc418d6a335',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Erro Para Solicitar Crédito de Voo',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_erro_para_solicitar_credito_de_voo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:04:41.959Z',
    updated_at: '2023-01-03T16:04:41.959Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6270aecf-8b80-11ed-a27c-f16178a15b0a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Tarifa Não Promocional',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_tarifa_nao_promocional_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:05:04.198Z',
    updated_at: '2023-01-03T16:05:04.198Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6edb64f2-8b80-11ed-adda-6fb4697899f8',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Crédito de Vôo::Regra de Acúmulo',
      tabulacao_tag: 'solicitacao_aereas_parceiras_credito_de_voo_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:05:25.030Z',
    updated_at: '2023-01-03T16:05:25.030Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '89bfb40a-8b80-11ed-99f7-4b26318164be',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Reembolso::Reembolso Tarifa VoeBiz',
      tabulacao_tag: 'solicitacao_aereas_parceiras_reembolso_reembolso_tarifa_voebiz_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:06:10.147Z',
    updated_at: '2023-01-03T16:06:10.147Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '98c5ae70-8b80-11ed-99f7-7f146f1314ba',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Reembolso::Reembolso Taxa de Embarque R$',
      tabulacao_tag: 'solicitacao_aereas_parceiras_reembolso_reembolso_taxa_de_embarque_r_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:06:35.352Z',
    updated_at: '2023-01-03T16:06:35.352Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ab2cad6c-8b80-11ed-8981-1505ee6c9cfb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Reembolso::Reembolso Taxa de Embarque Pontos',
      tabulacao_tag: 'solicitacao_aereas_parceiras_reembolso_reembolso_taxa_de_embarque_pontos_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:07:06.226Z',
    updated_at: '2023-01-03T16:07:06.226Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b665c100-8b80-11ed-a27c-374e650a4eeb',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Reembolso::Reembolso Loc Dividido',
      tabulacao_tag: 'solicitacao_aereas_parceiras_reembolso_reembolso_loc_dividido_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:07:25.055Z',
    updated_at: '2023-01-03T16:07:25.055Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c48ccd50-8b80-11ed-99f7-191d5e711091',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Reembolso::Reembolso SSR/Serviços/Taxas',
      tabulacao_tag: 'solicitacao_aereas_parceiras_reembolso_reembolso_ssrservicostaxas_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:07:48.799Z',
    updated_at: '2023-01-03T16:07:48.799Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd27d6070-8b80-11ed-b50f-fb7952a53f58',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Tarifa Comercial',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_tarifa_comercial_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:08:12.186Z',
    updated_at: '2023-01-03T16:08:12.186Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'df450397-8b80-11ed-b50f-2fc44dc56fb2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Aceito a Remarcação',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_aceito_a_remarcacao_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:08:33.627Z',
    updated_at: '2023-01-03T16:08:33.627Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'eaf6a282-8b80-11ed-adda-81b5e0cf2eea',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Alteração Diferença Tarifária',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_alteracao_diferenca_tarifaria_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:08:53.246Z',
    updated_at: '2023-01-03T16:08:53.246Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f960d21f-8b80-11ed-a27c-5d720a7ee448',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Falta de Disponibilidade',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_falta_de_disponibilidade_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:09:17.430Z',
    updated_at: '2023-01-03T16:09:17.430Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '05e92194-8b81-11ed-8981-13e113ab26ad',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Grupo de Risco',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_grupo_de_risco_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:09:38.456Z',
    updated_at: '2023-01-03T16:09:38.456Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1e9e0d4b-8b81-11ed-a27c-515d374a5f35',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Não Tem Nova Data Definida',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_nao_tem_nova_data_definida_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:10:19.907Z',
    updated_at: '2023-01-03T16:10:19.907Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2b9042f0-8b81-11ed-adda-3d4d7bf3407f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Não Vai Viajar',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_nao_vai_viajar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:10:41.627Z',
    updated_at: '2023-01-03T16:10:41.627Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '33ae5b19-8b81-11ed-99b0-05a9ccce16f0',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Queria Reitinerar',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_queria_reitinerar_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:10:55.246Z',
    updated_at: '2023-01-03T16:10:55.246Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '4049223b-8b81-11ed-99f7-596982507ff6',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Queria Trocar de Parceiro Aéreo',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_queria_trocar_de_parceiro_aereo_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:11:16.393Z',
    updated_at: '2023-01-03T16:11:16.393Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '49eddabf-8b81-11ed-8981-f34806074d47',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Flexibilização de Voos::Queria Trocar os Passageiros',
      tabulacao_tag: 'solicitacao_aereas_parceiras_flexibilizacao_de_voos_queria_trocar_os_passageiros_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:11:32.572Z',
    updated_at: '2023-01-03T16:11:32.572Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '554cc5b4-8b81-11ed-99b0-1d8c6eea5e77',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Bilhete::Envio de Bilhete',
      tabulacao_tag: 'solicitacao_aereas_parceiras_bilhete_envio_de_bilhete_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:11:51.649Z',
    updated_at: '2023-01-03T16:11:51.649Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '65e14f55-8b81-11ed-99b0-6bc78410a538',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Bilhete::Envio de Declaração - Embarque',
      tabulacao_tag: 'solicitacao_aereas_parceiras_bilhete_envio_de_declaracao_embarque_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:12:19.466Z',
    updated_at: '2023-01-03T16:12:19.466Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '6f8459ec-8b81-11ed-adda-ebda031a29a2',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Bilhete::Envio de Declaração - Valores',
      tabulacao_tag: 'solicitacao_aereas_parceiras_bilhete_envio_de_declaracao_valores_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:12:35.634Z',
    updated_at: '2023-01-03T16:12:35.634Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7bb3b3fd-8b81-11ed-b50f-b58357b1b550',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Antifraude::E-mail Marketing Fraude',
      tabulacao_tag: 'solicitacao_atendimento_antifraude_email_marketing_fraude_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:12:56.077Z',
    updated_at: '2023-01-03T16:12:56.077Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '8af9c4b3-8b81-11ed-8981-4577be2c4701',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Antifraude::Token Para Emissão',
      tabulacao_tag: 'solicitacao_atendimento_antifraude_token_para_emissao_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:13:21.702Z',
    updated_at: '2023-01-03T16:13:21.702Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9e0038a3-8b81-11ed-b50f-99741106da35',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Antifraude::Não Funcionamento do Token',
      tabulacao_tag: 'solicitacao_atendimento_antifraude_nao_funcionamento_do_token_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:13:53.621Z',
    updated_at: '2023-01-03T16:13:53.621Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'a96d7b87-8b81-11ed-99b0-fd2f5611c838',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Antifraude::Análise de Fraude',
      tabulacao_tag: 'solicitacao_atendimento_antifraude_analise_de_fraude_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:14:12.792Z',
    updated_at: '2023-01-03T16:14:12.792Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'bb274b3d-8b81-11ed-adda-eb58793917b3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Antifraude::Análise de Resgate Indevido',
      tabulacao_tag: 'solicitacao_atendimento_antifraude_analise_de_resgate_indevido_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:14:42.531Z',
    updated_at: '2023-01-03T16:14:42.531Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c95227ee-8b81-11ed-99b0-c532d1a313e1',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Atendimento::Atendimento::Concessão',
      tabulacao_tag: 'solicitacao_atendimento_atendimento_concessao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-03T16:15:06.300Z',
    updated_at: '2023-01-03T16:15:06.300Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd371dc83-8b81-11ed-adda-a31ea06af61d',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Destinos',
      tabulacao_tag: 'sugestao_destinos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:15:23.285Z',
    updated_at: '2023-01-03T16:15:23.285Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'dcd1c3be-8b81-11ed-99f7-3d613961b6dd',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Parceiros Aéreos',
      tabulacao_tag: 'sugestao_parceiros_aereos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:15:39.013Z',
    updated_at: '2023-01-03T16:15:39.013Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e34ab756-8b81-11ed-99b0-f319213d0e91',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Parceiros Financeiros',
      tabulacao_tag: 'sugestao_parceiros_financeiros_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:15:49.872Z',
    updated_at: '2023-01-03T16:15:49.872Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'ea1af2ca-8b81-11ed-adda-59b25e6fbbe9',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Produtos',
      tabulacao_tag: 'sugestao_produtos_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:16:01.303Z',
    updated_at: '2023-01-03T16:16:01.303Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f65745d7-8b81-11ed-99b0-130618b93411',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Aplicativo::Funcionalidades',
      tabulacao_tag: 'sugestao_aplicativo_funcionalidades_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:16:21.831Z',
    updated_at: '2023-01-03T16:16:21.831Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'fe816c0a-8b81-11ed-99b0-cb36fe30f303',
    external_id: null,
    attributes: {
      tabulacao_value: 'Sugestão::Novas Parceiras',
      tabulacao_tag: 'sugestao_novas_parceiras_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_sugestao',
    },
    created_at: '2023-01-03T16:16:35.529Z',
    updated_at: '2023-01-03T16:16:35.529Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '820b5389-a0d2-11ed-b95b-bb29169f4d6a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Informação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Regulamento',
      tabulacao_tag: 'informacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_informacao',
    },
    created_at: '2023-01-30T19:15:50.371Z',
    updated_at: '2023-01-30T19:15:50.371Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b67b3764-a0d5-11ed-9504-ef8ba36dee1a',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Atendimento::Solicitação Atrasada',
      tabulacao_tag: 'reclamacao_atendimento_solicitacao_atrasada_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T19:38:46.836Z',
    updated_at: '2023-01-30T19:38:46.836Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd8ebf0c4-a0d6-11ed-9d77-fbe1d3bcda0c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Nome Incorreto',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_nome_incorreto_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T19:46:54.114Z',
    updated_at: '2023-01-30T19:46:54.114Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'f6f1f152-a0d6-11ed-b70c-cdf772779587',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Cancel Vol. 24h Voo Após 7 Dias::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_gol_cancel_vol_24h_voo_apos_7_dias_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T19:47:44.485Z',
    updated_at: '2023-01-30T19:47:44.485Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '047ec42f-a0d8-11ed-9d77-4958eb10e59f',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Contestação',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_contestacao_voebiz',
      tabulacao_sla: 'sla_15_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T19:55:16.715Z',
    updated_at: '2023-01-30T19:55:16.715Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '2774a824-a0d8-11ed-9b43-ef06610dac05',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Emissão Parceiras Com Código Promocional',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_emissao_parceiras_com_codigo_promocional_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T19:56:15.369Z',
    updated_at: '2023-01-30T19:56:15.369Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'b9738be5-a0dc-11ed-9d77-c9f219dbfefe',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Disponibilidade Vôo',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_disponibilidade_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:28:58.296Z',
    updated_at: '2023-01-30T20:28:58.296Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c6e37cae-a0dc-11ed-9b43-b5028abf3832',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Erro ao Buscar Voo',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_erro_ao_buscar_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:29:20.840Z',
    updated_at: '2023-01-30T20:29:20.840Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '3564fa6d-a0dd-11ed-b70c-2b7386b9e1f3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Erro ao Selecionar Voo',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_erro_ao_selecionar_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:32:26.238Z',
    updated_at: '2023-01-30T20:32:26.238Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7422af05-a0dd-11ed-9d77-2f263804d7f3',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Emissão::Erro ao Selecionar Voo',
      tabulacao_tag: 'reclamacao_aereas_gol_emissao_erro_ao_selecionar_voo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:34:11.500Z',
    updated_at: '2023-01-30T20:34:11.500Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '941d5443-a0dd-11ed-9b43-271ef141af78',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Erro ao Concluir a Emissão',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_erro_ao_concluir_a_emissao_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:35:05.152Z',
    updated_at: '2023-01-30T20:35:05.152Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'afe65d83-a0dd-11ed-b70c-491362277169',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Erro ou Duplicidade no Pagamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_erro_ou_duplicidade_no_pagamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:35:51.768Z',
    updated_at: '2023-01-30T20:35:51.768Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'c21a8df6-a0dd-11ed-9b43-3d8b20fd83ae',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Erro Token',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_erro_token_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:36:22.309Z',
    updated_at: '2023-01-30T20:36:22.309Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'd1b0ba71-a0dd-11ed-9d77-43439c8bd1ea',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Assentos Indisponíveis',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_assentos_indisponiveis_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:36:48.459Z',
    updated_at: '2023-01-30T20:36:48.459Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'dca0425b-a0dd-11ed-af0f-11a93fc320fc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Taxa de Embarque Com Pontos',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_taxa_de_embarque_com_pontos_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:37:06.806Z',
    updated_at: '2023-01-30T20:37:06.806Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: 'e8b78109-a0dd-11ed-9d77-c9cc4f7080da',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - Parceiras::Emissão::Regulamento',
      tabulacao_tag: 'reclamacao_aereas_parceiras_emissao_regulamento_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-30T20:37:27.091Z',
    updated_at: '2023-01-30T20:37:27.091Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '164723f7-a0e1-11ed-b70c-f74d58c6330c',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Conta VoeBiz::Extrato / Saldo::Acúmulo Não Processado',
      tabulacao_tag: 'solicitacao_conta_voebiz_extrato_saldo_acumulo_nao_processado_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-01-30T21:00:12.020Z',
    updated_at: '2023-01-30T21:00:12.020Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '496348be-a18c-11ed-9d77-ddfeaf523105',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Aéreas - GOL::Regra de Acúmulo',
      tabulacao_tag: 'reclamacao_aereas_gol_regra_de_acumulo_voebiz',
      tabulacao_sla: 'sla_5_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-01-31T17:25:41.709Z',
    updated_at: '2023-01-31T17:25:41.709Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '7f70a81e-a231-11ed-a316-a77a29cbf463',
    external_id: null,
    attributes: {
      tabulacao_value: 'Reclamação::Conta VoeBiz::Senha::Mensagem de Erro Senha',
      tabulacao_tag: 'reclamacao_conta_voebiz_senha_mensagem_de_erro_senha_voebiz',
      tabulacao_sla: 'sla_10_dias_corridos',
      tabulacao_group: 'grupo_backoffice_voebiz_reclamacao',
    },
    created_at: '2023-02-01T13:08:19.354Z',
    updated_at: '2023-02-01T13:09:57.000Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '9b7fa249-a236-11ed-8a1b-fbf09b93f3cc',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - GOL::Emissão::Cancelamento Parcial GOL',
      tabulacao_tag: 'solicitacao_aereas_gol_emissao_cancelamento_parcial_gol_voebiz',
      tabulacao_sla: 'sla_nao_ha',
      tabulacao_group: 'grupo_central_de_atendimento_voebiz_solicitacao',
    },
    created_at: '2023-02-01T13:44:53.912Z',
    updated_at: '2023-02-01T13:44:53.912Z',
  },
  {
    type: 'tabulacao_motivo_cont_voebiz',
    id: '1a822ed8-a23c-11ed-8ab0-9f47917a510e',
    external_id: null,
    attributes: {
      tabulacao_value: 'Solicitação::Aéreas - Parceiras::Não Comparecimento ao Embarque::Regulamento',
      tabulacao_tag: 'solicitacao_aereas_parceiras_nao_comparecimento_ao_embarque_regulamento_voebiz',
      tabulacao_sla: 'sla_10_dias_uteis',
      tabulacao_group: 'grupo_backoffice_voebiz_solicitacao',
    },
    created_at: '2023-02-01T14:24:14.483Z',
    updated_at: '2023-02-01T14:24:14.483Z',
  },
];
